<template>
  <div style="height: 100%; width:100%">
    <!-- Dialog da dependencia -->
    <p-dependency v-if="!shared" ref="taskDependency" :task_id="editedItem['id']" @updateDependencyLength="(values) => Object.assign(this.dependency_length, values)"></p-dependency>
    <!-- Dialog tarefas compartilhada -->
    <p-share-task ref="shareTask" :task_id="editedItem.id" :shared="editedItem.shared" :password="editedItem.password" @input="(val) => { Object.assign(editedItem, val) }"></p-share-task>
    <!-- Dialog com que mostra a previsualização do documento -->
    <p-document-preview ref="documentPreview"></p-document-preview>
    <!--Dialog para inserir senha da tarefa-->
    <v-dialog v-model="dialog_password" @keydown.enter="confirmPassword" persistent max-width="300" scrollable>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
        Insira a senha
        </v-card-title>
        <v-card-text justify-center>
          <v-form autocomplete="off" @submit.prevent="">
            <v-flex xs12>
              <v-text-field id="password" prepend-icon="lock" name="password" label="Senha"
                type="password" v-model="task_password" />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="confirm_password" class="mx-0" flat color="primary" @click.native="confirmPassword">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- confirmação de exclusão de arquivos -->
    <div class="text-xs-center">
      <v-dialog v-model="filesDialog" @keydown.enter="deleteFileProcess(true)" @keydown.esc="cancelFileProcess" persistent max-width="500" scrollable>
        <v-card>
          <v-card-text justify-center>
            <p class="text-md-center">{{'Essa tarefa possui alguns arquivos! O que gostaria de fazer com eles?'}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="keep_file" class="mx-0" flat color="primary" @click.native="deleteFileProcess(false)">{{'Manter na biblioteca'}}</v-btn>
            <v-btn id="delete_file" class="mx-0" flat color="red" @click.native="deleteFileProcess(true)">{{'Excluir do Sistema'}}</v-btn>
            <v-btn id="cancel_file" class="mx-0" flat @click.native="cancelFileProcess">{{'Cancelar'}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- confirmação de deleção de recorrencia -->
    <div class="text-xs-center">
      <v-dialog v-model="recurDialog" @keydown.enter="deleteRecurProcess(true)" @keydown.esc="cancelRecurProcess" persistent max-width="650" scrollable>
        <v-card>
          <v-card-text justify-center>
            <p class="text-md-center">{{'Esta Tarefa possui uma Recorrência, o que gostaria de fazer com ela?'}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="delete_task" class="mx-0" flat color="primary" @click.native="deleteRecurProcess(false)">{{'Excluir a Tarefa'}}</v-btn>
            <v-btn id="delete_rec_task" class="mx-0" flat color="red" @click.native="deleteRecurProcess(true)">{{'Excluir a Tarefa e a Recorrência'}}</v-btn>
            <v-btn id="cancel_delete" class="mx-0" flat @click.native="cancelRecurProcess">{{'Cancelar'}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- <p-confirm :text="'Deseja excluir os arquivos desta tarefa'" :dialog="filesDialog" @confirm="deleteFileProcess(true)" @cancel="deleteFileProcess(false)"></p-confirm> -->
    <!--Dialog para confirmação de exclusão-->
    <p-confirm :text="view === 2 ? 'Ao salvar sem Previsão preenchida, os lembretes do Modelo de Tarefa não serão incluídos. Deseja salvar mesmo assim' : 'Tem certeza que deseja excluir o item de Tarefas'" :dialog="dialogConfirm" @confirm="confirmDialog" @cancel="() => {this.dialogConfirm = false}"></p-confirm>
    <!-- quando for mobile ($vuetify.breakpoint.smAndDown) estava dando uma magen do card-task ficando um espaço transparente -->
    <v-card :class="$vuetify.breakpoint.smAndDown ? '' : 'card-task'" style="height: 100%;">
      <!--Cabeçalho-->
      <v-card-title class="py-2">
        <v-layout v-if="view === 4" align-center justify-space-between wrap>
          <v-flex shrink>
            <v-tooltip bottom>
              <v-btn id="close_task_editable" slot="activator" icon @click="close()">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Fechar</span>                  
            </v-tooltip>
          </v-flex>
          <v-flex shrink>
            <v-progress-circular v-if="loading_values" :indeterminate="true"></v-progress-circular>
            <span v-else>
              <span>ID: </span>
              <v-hover v-for="son in sons" :key="son.id" >
                <span slot-scope="{ hover }">
                  <v-chip :id="'select_task_' + son.id" outline @click="selectTask(son.id, shared)" :color="son.id === editedItem.id || hover ? 'primary' : ''" :selected="son.id === editedItem.id || hover">
                    <span :style="son.id === editedItem.id ? 'textAlign: center; fontSize: 15pt; textDecoration: underline; color: #02444d; fontWeight: bold;' : 'textAlign: center; fontSize: 13pt; textDecoration: underline; color: #7e8e90; cursor: pointer;'">
                      {{son.identifier}}
                    </span>
                  </v-chip>
                  <span v-if="son.id !== sons[sons.length - 1].id" style="textAlign: center; fontSize: 20pt; color: #7e8e90">.</span>
                </span>
              </v-hover>
            </span>
          </v-flex>
          <v-flex grow class="text-xs-right">

            <v-layout align-center justify-end row fill-height v-if="!shared">
              <v-menu left nudge-top="8" content-class="elevation-0 menu_content" transition="slide-x-reverse-transition" :offset-x="true">
                <!-- <template v-slot:activator="{ on, attrs }"> -->
                <v-btn :id="'task_more_btn'" slot="activator" v-if="$vuetify.breakpoint.smAndDown" fab small icon class="mx-0">
                  <v-icon large>more_vert</v-icon>
                </v-btn>
                <!-- </template> -->
                <!-- <v-tooltip bottom>
                  <v-btn slot="activator" v-if="view === 4" small fab @click="dialogDelete(editedItem)" :disabled="shared || !checkPermission(entity, 'delete') || !this.editedItem.crud_access">
                    <v-icon color="gray">expand</v-icon>
                  </v-btn>
                  <span>Expandir</span>
                </v-tooltip> -->

                <v-tooltip bottom :slot="$vuetify.breakpoint.smAndDown ? null : 'activator'">
                  <!-- Desabilita o alarme caso esteja em uma tarefa compartilhada ou o usuário seja de uma empresa diferente da tarefa(parceiro) e esteja no plano free -->
                  <v-btn id="btn_start_duration" slot="activator" v-if="view === 4" small fab @click="startDuration(editedItem)" :disabled="(checkIsFree() && editedItem.company_id != $auth.user().company_id)">
                    <v-icon color="purple">alarm</v-icon>
                  </v-btn>
                  <span>Iniciar Tempo</span>
                </v-tooltip>
              
                <v-tooltip bottom :slot="$vuetify.breakpoint.smAndDown ? null : 'activator'">
                  <v-btn id="btn_delete_task" slot="activator" v-if="view === 4" small fab @click="dialogDelete(editedItem)" :disabled="!checkPermission(entity, 'delete') || !this.editedItem.crud_access">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>{{deleteTooltipText}}</span>
                </v-tooltip>

                <v-tooltip bottom :slot="$vuetify.breakpoint.smAndDown ? null : 'activator'">
                  <!-- Desabilita o alarme caso esteja em uma tarefa compartilhada ou o usuário seja de uma empresa diferente da tarefa(parceiro) e esteja no plano free -->
                  <v-btn id="btn_dependency_task" small fab slot="activator" :disabled="!mountDepend || !this.editedItem.crud_access || checkIsFree()" :loading="!mountDepend" v-if="view === 4" @click="$refs.taskDependency.openDialogDependency()">
                    <v-badge left :color="dependency_length['color'] === 'green' ? 'green' : 'primary'">
                      <template v-slot:badge>
                        <span>{{dependency_length['total']}}</span>
                      </template>
                      <v-icon :color="dependency_length['color']">mediation</v-icon>
                    </v-badge>
                  </v-btn>
                  <span>{{checkIsFree() ? 'Seu plano não possui acesso a adição de pré-requisitos. Faça upgrade para o plano Business!' : 'Tarefas pré-requisitos'}}</span>
                </v-tooltip>
                
                <v-tooltip bottom :slot="$vuetify.breakpoint.smAndDown ? null : 'activator'">
                  <v-btn id="btn_share_task" slot="activator" :loading="false" small color="grey lighten-4" fab :disabled="!this.editedItem.crud_access" v-if="view === 4" @click="$refs.shareTask.openDialog()">
                    <v-icon :color="editedItem['shared'] ? 'teal' : 'black'">link</v-icon>
                  </v-btn>
                  <span >{{editedItem['shared'] ? 'Compartilhado publicamente' : 'Compartilhar tarefa'}}</span>
                </v-tooltip>
                
                <v-tooltip bottom :slot="$vuetify.breakpoint.smAndDown ? null : 'activator'" v-if="view === 4 && editedItem['tasktemplate_id'] && editedItem['company_id'] === $auth.user().company_id && editedItem['level'] == 1">
                  <v-btn small fab class="mx-0" slot="activator" @click="$refs.documentPreview.openDocumentPreviewList(editedItem['id'], editedItem['tasktemplate_id'])">
                    <v-icon color="blue">description</v-icon>
                  </v-btn>
                  <span>Documentos Personalizados</span>
                </v-tooltip>
                
                <v-tooltip bottom :slot="$vuetify.breakpoint.smAndDown ? null : 'activator'" v-if="!$vuetify.breakpoint.smAndDown && !isOtherPage">
                  <v-btn id="btn_open_fullscreen"  v-if="taskFullscreen" slot="activator" small fab @click="$emit('openTaskFullscreen')" ><v-icon>close_fullscreen</v-icon></v-btn>
                  <v-btn id="btn_close_fullscreen"  v-else slot="activator" small fab @click="$emit('openTaskFullscreen')" ><v-icon>open_in_full</v-icon></v-btn>
                  <span>{{ taskFullscreen ? 'Fechar tela cheia' : 'Abrir em tela cheia' }}</span>                  
                </v-tooltip>
                
              </v-menu>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
              <!-- keydown.enter.exact.prevent serve pra quando apertar enter não quebrar uma linha -->
              <v-form slot-scope="{ hover }" ref="task_id_text_form">
                <v-textarea id="task_id_text" v-if="fieldEditing['task_id_text']" ref="autofocus" maxlength="190" counter="190" rows="1" v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'),190)" auto-grow @keydown.enter.exact.prevent
                @keyup.enter.exact="fieldEdit({id_text: editedItem.id_text}, 'task_id_text')"
                @blur="fieldEdit({id_text: editedItem.id_text}, 'task_id_text')" 
                style="padding-top:0;margin-top:0;"
                ></v-textarea>
                <div id="task_id_text" v-else @click="clickFieldEdit('task_id_text')"  :class="hover ? 'show-edit-border' : 'show-edit'">
                  <div class="p-content-id-text break-word"> {{editedItem.id_text}}</div>
                </div>
              </v-form>
            </v-hover>
          </v-flex>
        </v-layout>

        <v-layout v-else align-center>
          <v-flex shrink>
            <v-tooltip bottom>
              <v-btn id="close_task_id_text" slot="activator" icon @click="close()">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Fechar</span>                  
            </v-tooltip>
          </v-flex>
          <v-flex grow>
            <!-- <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span> -->
            <span class="headline">{{formTitle}}</span>
            &emsp;
          </v-flex>
          <!-- </v-layout> -->
        </v-layout>

      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0" style="overflow-y: auto; overflow-x: hidden; height: 80%;">
        <v-layout row wrap  >
          <!--Management-->
          <v-flex v-if="view === 4" :class="qtdCustomFields > 0 ? 'xs12 sm8' : 'xs12'">
          <v-layout row wrap class="pa-4">
            <!-- ---- identifier ---- -->
            <v-flex xs12 v-if="editedItem['level'] > 1">
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }"  ref="task_identifier_form">
                  <v-text-field id="task_identifier" v-if="fieldEditing['task_identifier']" type="number"  :label="translate('table.' + entity + '.field.identifier')" v-model="editedItem.identifier" @keyup.enter="fieldEdit({identifier: editedItem.identifier}, 'task_identifier')" @blur="fieldEdit({identifier: editedItem.identifier}, 'task_identifier')" :rules="requiredRule(translate('table.' + entity + '.field.identifier'))" 
                  ></v-text-field>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                  <v-layout>
                    <v-flex xs12>
                      <div id="task_identifier" @click="clickFieldEdit('task_identifier')">
                        <div class="p-label">{{translate('table.' + entity + '.field.identifier')}}</div>
                        <div class="p-content-task"> {{editedItem.identifier}}</div>
                      </div>
                    </v-flex>
                  </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- status ---- -->
            <v-flex xs12 sm6>
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                  <p-select-modal-editable id="task_status_id" v-if="fieldEditing['task_status_id']" :companyId="editedItem['company_id']" :showActions="editedItem.company_id === $auth.user().company_id" :clearable="false" :label="translate('table.' + entity + '.field.task_status_id')" @change="changeStatus" v-model="editedItem.task_status_id" :selectedItem="editedItem.status" :onlyThisItems="selectedBoard['properties']['status']" :rules="requiredRule(translate('table.' + entity + '.field.task_status_id'))" entity="task_status" placeholder="Não Iniciada" :values="status_fields">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="status_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="status_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                        </v-flex>
                        <v-switch label="Status de conclusão" :value=3 v-model="status_fields.identifier"></v-switch>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                    <div id="task_status_id" @click="clickFieldEdit('task_status_id')">
                      <div class="p-label">{{translate('table.' + entity + '.field.task_status_id')}}</div>
                      <div v-if="editedItem.task_status_id" class="p-content-task one-line" :style="`color:${editedItem.status['color']}`">{{editedItem.status['id_text']}}</div>
                      <div v-else class="p-content-task-empty one-line">{{'Não Iniciada'}}</div>
                    </div>
                  </div>
                </v-form>
              </v-hover>
              <div>
              </div>
            </v-flex>
            <!-- ---- urgency ---- -->
            <v-flex xs12 sm6>
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                  <v-select id="task_urgency" content-class="task_urgency_class" v-if="fieldEditing['task_urgency']" :label="translate('table.' + entity + '.field.urgency')" @click:clear="$nextTick(() => editedItem.urgency=null)" v-model="editedItem.urgency" :items="translate('value.task_urgency')" @change="fieldEdit({urgency: editedItem.urgency}, 'task_urgency')" @blur="fieldEditing['task_urgency'] = false"></v-select>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                    <v-layout>
                      <v-flex xs11>
                        <div id="task_urgency" @click="clickFieldEdit('task_urgency')">
                          <div class="p-label">{{translate('table.' + entity + '.field.urgency')}}</div>
                          <div v-if="editedItem.urgency" class="p-content-task" :style="`color:${translate('value.task_urgency').find((val)=>{ return val.value === editedItem.urgency }).color_solid}`">{{translate('value.task_urgency').find((val)=>{ return val.value === editedItem.urgency }).text}}</div>
                          <div v-else class="p-content-task-empty">{{shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip v-if="editedItem.urgency != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                          <v-btn id="close_task_urgency" class="btn-close-edit" slot="activator" icon @click="fieldEdit({urgency: null}, 'task_urgency')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- prevision date ---- -->
            <v-flex xs12>
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }" ref="task_dates_form">
                  <p-task-dates ref="taskDates" :task="editedItem" @confirm="(values) => fieldEdit(values, 'task_dates')"></p-task-dates>
                  <div :class="hover ? 'show-edit-border' : 'show-edit'">
                    <v-layout>
                      <v-flex xs11>
                        <div @click="clickFieldEditDates()">
                          <div class="p-label">{{editedItem.commitment === 1 ? 'Data de Compromisso' : translate('table.' + entity + '.field.end')}}</div>
                          <div class="p-content-task" v-if="editedItem.commitment === 1"> {{!editedItem.end ? moment(editedItem.begin).format("DD/MM/YYYY") : moment(editedItem.begin).format("DD/MM/YYYY HH:mm:ss") + ' até ' + moment(editedItem.end).format("DD/MM/YYYY HH:mm:ss")}}</div>
                          <div v-else-if="editedItem.end" class="p-content-task"> {{moment(editedItem.end).format("DD/MM/YYYY HH:mm:ss")}}</div>
                          <div v-else class="p-content-task-empty">{{shared ? 'Campo vazio' : 'Escolha uma data'}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip v-if="editedItem.end != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                          <v-btn slot="activator" icon class="btn-close-edit" @click="fieldEdit({begin: null, end: null, commitment: 0}, 'task_dates')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- team ---- -->
            <v-flex xs12 sm6 v-if="checkPlanAccess('teams', 'active')">
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                  <p-select id="task_team_id" v-if="fieldEditing['task_team_id']" entity="task_team" :disabled="(editedItem.level !== 1) || (editedItem.company_id !== $auth.user().company_id)" :label="translate('table.' + entity + '.field.team_id')" v-model="editedItem.team_id" @change="(id, item) => {changeTeam(id, item, true)}" @blur="fieldEditing['task_team_id'] = false" :companyId="editedItem['company_id']" :onlyThisItems="selectedBoard['properties']['team_id']"></p-select>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                  <v-layout>
                    <v-flex xs11>
                      <div id="task_team_id" @click="clickFieldEdit('task_team_id')">
                        <div class="p-label">{{translate('table.' + entity + '.field.team_id')}}</div>
                        <div v-if="editedItem.team" class="p-content-task one-line"> {{editedItem.team.id_text}}</div>
                        <div v-else class="p-content-task-empty one-line">{{shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                      </div>
                    </v-flex>
                    <v-flex xs1>
                      <v-tooltip class="btn-close-edit" v-if="editedItem.team_id != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                        <v-btn id="close_task_team_id" slot="activator" icon @click="changeTeam(null, null, true)"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- user ---- -->
            <v-flex :class="checkPlanAccess('teams', 'active') ? 'xs12 sm6' : 'xs12'">
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                  <!-- // Usado o v-show po:notSearchUserIllis="!!editedItem.team_id || (editedItem.company_id !== ($auth.check() ? $auth.user().company_id : 0))" is quando o usuário de outra empresa não possui plano, mostra uma ms que esta no p-select-user -->
                  <p-select-user id="task_user_id" v-show="fieldEditing['task_user_id']" :needCompanyPlan="true" :disabled="loading_users" :loading="loading_users" ref="userIllis" v-model="selectedUser" :teamId="editedItem['team_id']" :label="translate('table.' + entity + '.field.user_id')" @input="(val) => { changeResponsible(val, true) }" @blur="fieldEditing['task_user_id'] = false" :users="users" :selectedItem="selectedUser" :outCompanyId="editedItem['company_id']"></p-select-user>
                  <div v-show="!fieldEditing['task_user_id']" :class="hover ? 'show-edit-border' : 'show-edit'">
                    <v-layout>
                      <v-flex xs11>
                        <div id="task_user_id" @click="clickFieldEditUser()">
                          <div class="p-label">{{translate('table.' + entity + '.field.user_id')}}</div>
                          <div class="p-content-task one-line" v-if="!$auth.check()">{{(editedItem.user_id ? editedItem.user.id_text : 'Sem responsável')}}</div>
                          <div class="p-content-task-empty one-line" v-else-if="!editedItem.user_id">{{shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                          <div class="p-content-task one-line" v-else-if="editedItem.company_id === $auth.user().company_id">{{ editedItem.user.id_text+(editedItem.connection_company ? ('('+editedItem.connection_company.id_text+')') : '')}}</div>
                          <div class="p-content-task one-line" v-else-if="editedItem.connection_company_id">{{ editedItem.user.id_text+(editedItem.connection_company_id === $auth.user().company_id ? '' : ('('+editedItem.connection_company.id_text+')')) }}</div>
                          <div class="p-content-task one-line" v-else>{{ editedItem.user.id_text+((' ('+editedItem.company.id_text+')'))}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip v-if="editedItem.user_id != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                          <v-btn id="close_task_user_id" class="btn-close-edit" slot="activator" icon @click="changeResponsible({id: null}, true)"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- client ---- -->
            <v-flex xs12 sm6 v-show="showMoreFields">
              <v-form>
                <p-select id="task_client_id" v-if="fieldEditing['task_client_id']" entity="task_client" :disabled="(editedItem.level !== 1) || (editedItem.company_id !== $auth.user().company_id)" :label="translate('table.' + entity + '.field.client_id')" :filter="filterAutocomplete" v-model="editedItem.client_id" @change="(id, item) => fieldEdit({client_id: id, client: item}, 'task_client_id')" @blur="fieldEditing['task_client_id'] = false" :companyId="editedItem['company_id']"></p-select>
                <v-layout id="task_client_id" v-else wrap class="ma-0">
                  <v-flex :class="(editedItem.client_id && !shared) ? 'xs10 pa-0' : 'xs12 pa-0'">
                    <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                      <div slot-scope="{ hover }"  :class="hover ? 'show-edit-border' : 'show-edit'">
                        <v-layout>
                          <v-flex xs11>
                            <div @click="clickFieldEdit('task_client_id')">
                              <div class="p-label">{{translate('table.' + entity + '.field.client_id')}}</div>
                              <div v-if="editedItem.client_id" class="p-content-task one-line">{{editedItem.client.id_text}}</div>
                              <div v-else class="p-content-task-empty one-line">{{shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                            </div>
                          </v-flex>
                          <v-flex xs1>
                            <v-tooltip v-if="editedItem.client_id != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                              <v-btn id="close_task_client_id" slot="activator" class="btn-close-edit" icon @click="fieldEdit({client_id: null, client: null}, 'task_client_id')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-hover>
                  </v-flex>
                  <v-flex :class="editedItem.client_id ? 'xs2 pa-0' : 'pa-0'" v-if="editedItem.client_id && !shared">
                    <p-view-client :client_id="editedItem.client_id" :task_id="editedItem.id"></p-view-client>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            <!-- ---- category ---- -->
            <v-flex xs12 sm6 v-show="showMoreFields">
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                  <p-select-modal-editable v-if="fieldEditing['task_category_id']" id="task_category_id" entity="task_category" :showActions="editedItem.company_id === $auth.user().company_id || editedItem.identifier === ''" :label="translate('table.' + entity + '.field.category_id')" v-model="editedItem.category_id" :selectedItem="editedItem.category" :values="category_fields" @change="(id, item) => fieldEdit({category_id: id, category: item}, 'task_category_id')" :clearable="false" :companyId="editedItem['company_id']" :onlyThisItems="selectedBoard['properties']['category']">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="category_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_category.field.id_text')"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                    <v-layout>
                      <v-flex xs11>
                        <div @click="clickFieldEdit('task_category_id')">
                          <div class="p-label">{{translate('table.' + entity + '.field.category_id')}}</div>
                          <div v-if="editedItem.category_id" class="p-content-task one-line">{{editedItem.category.id_text}}</div>
                          <div v-else class="p-content-task-empty one-line">{{shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip v-if="editedItem.category_id != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                          <v-btn slot="activator" icon class="btn-close-edit" @click="fieldEdit({category_id: null, category: null}, 'task_category_id')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- recurrence ---- -->
            <v-flex xs12 v-if="editedItem.level === 1" v-show="showMoreFields">
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                    <recurrence v-if="fieldEditing['task_recurrence']" id="task_recurrence" ref="taskRecurrence" :commitment="editedItem.commitment" :disabled="checkIsFree()" :value="editedItem.recurrence" @getRecurrence="(val) => {recurrenceChangeProcess(val)}" :recurrenceText="recurText" @delete="fieldEdit({recurrence_id: null, recurrence: {type: '', id_text: {each: '', days: '', months: ''}}}, 'task_recurrence')" @confirm="(val) => {fieldEdit({recurrence: val}, 'task_recurrence')}"></recurrence>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                    <v-layout>
                      <v-flex xs11>
                        <div @click="clickFieldEditRecurrence()">
                          <div class="p-label">{{translate('table.' + entity + '.field.recurrence_id')}}</div>
                          <div v-if="recurText" class="p-content-task">{{recurText}}</div>
                          <div v-else class="p-content-task-empty">{{shared ? 'Campo vazio' : 'Escolha uma recorrência'}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip v-if="editedItem.recurrence_id != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                          <v-btn slot="activator" icon class="btn-close-edit" @click="fieldEdit({recurrence_id: null, recurrence: {type: '', id_text: {each: '', days: '', months: ''}}}, 'task_recurrence')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <!-- ---- note ---- -->
            <v-flex xs12 v-show="showMoreFields">
              <v-hover :disabled="shared || $vuetify.breakpoint.smAndDown">
                <v-form slot-scope="{ hover }">
                  <v-textarea id="task_note"  v-if="fieldEditing['task_note']" maxlength="10000" counter="10000" rows="2" :label="translate('table.' + entity + '.field.note')" name="note" v-model="editedItem.note" auto-grow @blur="fieldEdit({note: editedItem.note}, 'task_note')" >
                  </v-textarea>
                  <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                    <v-layout>
                      <v-flex xs11>
                        <div @click="clickFieldEdit('task_note')">
                          <div class="p-label">{{translate('table.' + entity + '.field.note')}}</div>
                          <div v-if="editedItem.note" class="p-content-task break-word" style="white-space: pre-line;"> {{editedItem.note}}</div>
                          <div v-else class="p-content-task-empty break-word">{{shared ? 'Campo vazio' : 'Digite uma observação'}}</div>
                        </div>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip v-if="editedItem.note != null && (hover || $vuetify.breakpoint.smAndDown) && !shared" bottom>
                          <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({note: null}, 'task_note')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
            <a color="primary" small @click="showMoreFields = !showMoreFields">{{showMoreFields ? 'Mostrar menos campos' : 'Mostrar mais campos...'}}<v-icon small>{{showMoreFields ? 'expand_less' : 'expand_more'}}</v-icon></a>
          </v-layout>
          </v-flex>
          <!--Create Edit-->
          <v-flex v-else :class="qtdCustomFields > 0 ? 'xs12 sm8' : 'xs12'">
            <v-form v-model="valid" lazy-validation ref="form" class="pa-4" style="height: 100%">
              <v-layout row justify-space-between wrap>
                <!--Tarefa Modelo-->
              <!-- <v-layout align-center justify-center row fill-height> -->
              <v-flex xs12 class="break-word">
                <!-- // v-if inserido pois quando é subtarefa não deve ter as validações da tarefa modelo -->
                <!-- // tasktemplate -->
                <v-autocomplete id="task_template" outline hide-details v-if="editedItem.level === 1 && checkPlanAccess('tasktemplates', 'active')"  :disabled="!checkPlanAccess('tasktemplates', 'has') || !!this.selectedBoard['tasktemplate_id']" label="Modelo de Tarefa (POP)" name="tasktemplate" :rules="(notEmptyArray(selectedBoard['properties']['task_template_id']) || selectedBoard['properties']['task_template_id'] > 0) ? requiredRule(translate('table.' + entity + '.field.tasktemplate_id')) : []"
                clearable v-model="tasktemplate" :items="tasktemplates" item-text="id_text" item-value="id" return-object @change="changeTasktemplate" :filter="filterAutocomplete">
                  <template v-slot:selection="data">
                    <div class="break-word two-line">
                      {{data.item.identifier + ' - ' + data.item.id_text}}
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <div class="break-word two-line">
                      {{data.item.identifier + ' - ' + data.item.id_text}}
                    </div>
                  </template>
                </v-autocomplete>
              </v-flex>
                <!-- // identifier -->
                <!-- <v-flex xs2 v-show="view === 3">
                  <v-text-field id="task_identifier" @keyup.native.ctrl.enter="saveEdit()" :readonly="editedItem.level === 1" :label="translate('table.' + entity + '.field.identifier')" v-model="editedItem.identifier"></v-text-field>
                </v-flex> -->
                <!-- // id_text -->
                <v-flex xs12>
                  <v-textarea id="task_id_text" :key="forceAutoGrow" @keyup.native.ctrl.enter="saveEdit()" ref="autofocus" maxlength="190" :label="translate('table.' + entity + '.field.id_text')" counter="190" rows="1" v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'),190)" auto-grow></v-textarea>
                </v-flex>
                <!-- // prevision -->
                <v-flex xs12>
                  <v-layout justify-space-between>
                    <v-flex grow>
                      <v-tooltip bottom>
                        <v-checkbox id="task_commitment" slot="activator" xs6 @change="(val) => {editedItem.begin = null}" label="Compromisso" style="height: 20px; margin-top: 0px;" v-model="editedItem.commitment" :true-value="1" :false-value="0"></v-checkbox>
                        <span>Ao marcar esse campo essa tarefa será um compromisso com data inicio e previsão.</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex shrink v-if="editedItem.commitment === 1 && moment(editedItem.end).isValid() && moment(editedItem.begin).isValid()" style="padding-top: 8px; padding-bottom: 0px;">
                      <span>{{'Duração de ' + moment.duration(moment(editedItem.end).diff(editedItem.begin)).format("h [hrs] m [min]")+'.'}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap justify-center align-center>
                    <v-flex v-if="editedItem.commitment === 1" xs12 sm6>
                      <p-date-time id="task_begin" @keyup.native.ctrl.enter="saveEdit()"
                        :label="translate('table.' + entity + '.field.begin')"
                        :defaultHour="'00:00'"
                        @onChange="() => {if (!editedItem.end || editedItem.end.length === 0) setEnd()}"
                        v-model="editedItem.begin" :rules="dateDiffRule().concat(requiredRule(translate('table.' + entity + '.field.begin'),190))"
                      ></p-date-time>
                    </v-flex>
                    <v-flex :class="editedItem.commitment === 1 ? 'xs12 sm6' : 'xs12'" >
                      <p-date-time id="task_end" @keyup.native.ctrl.enter="saveEdit()"
                        :label="translate('table.' + entity + '.field.end')"
                        :defaultHour="'23:59'"
                        v-model="editedItem.end" :rules="this.editedItem.commitment === 1 ? dateDiffRule().concat(requiredRule(translate('table.' + entity + '.field.end'),190)) : dateDiffRule()"
                      ></p-date-time>
                    </v-flex>

                  </v-layout>
                </v-flex>
                <!-- status -->
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="task_status_id" :showActions="editedItem.company_id === $auth.user().company_id || editedItem.identifier === ''" :clearable="false" :label="translate('table.' + entity + '.field.task_status_id')" v-model="editedItem.task_status_id" @change="(id, item) => {editedItem['status'] = item}" entity="task_status" :values="status_fields" placeholder="Não Iniciada" :selectedItem="editedItem['status']" :onlyThisItems="selectedBoard['properties']['status']" :companyId="editedItem['company_id']" :rules="(editedItem['level'] === 1 && notEmptyArray(selectedBoard['properties']['status'])) ? requiredRule(translate('table.' + entity + '.field.task_status_id')) : []">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="status_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="status_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                        </v-flex>
                        <v-switch label="Status de conclusão" :value=3 v-model="status_fields.identifier"></v-switch>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <!-- urgency -->
                <v-flex xs12 sm6>
                  <v-select id="task_urgency" content-class="task_urgency_class" @keyup.native.ctrl.enter="saveEdit()" :label="translate('table.' + entity + '.field.urgency')" :filter="filterAutocomplete" clearable @click:clear="$nextTick(() => editedItem.urgency=null)" v-model="editedItem.urgency" :items="translate('value.task_urgency')"></v-select>
                </v-flex>
                <!-- team -->
                <v-flex :class="qtdCustomFields > 0?'xs12':'xs12 sm6'" v-if="checkPlanAccess('teams', 'active')">
                  <!-- // nos rules da equipe pode ser tanto array como integer quando so tem um valor -->
                  <p-select id="task_team_id" entity="task_team" :onlyThisItems="selectedBoard['properties']['team_id']" :disabled="(editedItem.level !== 1)" :label="translate('table.' + entity + '.field.team_id')" v-model="editedItem['team_id']" @change="changeTeam" clearable :selectedItem="editedItem.team" :companyId="editedItem['company_id']" :rules="editedItem['level'] === 1 && (notEmptyArray(selectedBoard['properties']['team_id']) || selectedBoard['properties']['team_id'] > 0) ? requiredRule(translate('table.' + entity + '.field.team_id')) : []"></p-select>
                </v-flex>
                <!-- user -->
                <v-flex :class="checkPlanAccess('teams', 'active') && (qtdCustomFields === 0) ? 'xs12 sm6' : 'xs12'">
                  <p-select-user id="task_user_id" :needCompanyPlan="true" @keyup.native.ctrl.enter="saveEdit()" :disabled="loading_users" :loading="loading_users" ref="userIllis" v-model="selectedUser" :label="translate('table.' + entity + '.field.user_id')" @input="changeResponsible" :users="users" clearable :companyId="editedItem['company_id']"></p-select-user>
                </v-flex>
                <!-- client -->
                <v-flex xs12 sm6>
                  <p-select id="task_client_id" entity="task_client" :disabled="(editedItem.level !== 1) || (editedItem.company_id !== $auth.user().company_id)" :label="translate('table.' + entity + '.field.client_id')" v-model="editedItem.client_id" multiple clearable :selectedItem="editedItem.client" :companyId="editedItem['company_id']" :onlyThisItems="selectedBoard['properties']['client']" :rules="editedItem['level'] === 1 && notEmptyArray(selectedBoard['properties']['client']) ? requiredManyRule(translate('table.' + entity + '.field.client_id')) : []"></p-select>
                </v-flex>
                <!-- category -->
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="task_category_id" entity="task_category"
                    :showActions="editedItem.company_id === $auth.user().company_id || editedItem.identifier === ''"
                    :label="translate('table.' + entity + '.field.category_id')"
                    @change="(id, item) => {Object.assign(editedItem, {category_id: id, category: item})}"
                    v-model="editedItem.category_id" :selectedItem="editedItem.category" :onlyThisItems="selectedBoard['properties']['category']" :companyId="editedItem['company_id']" :values="category_fields" clearable :rules="editedItem['level'] === 1 && notEmptyArray(selectedBoard['properties']['category']) ? requiredRule(translate('table.' + entity + '.field.category_id')) : []">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="category_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_category.field.id_text')"></v-text-field>
                        </v-flex>
                        <!-- O campo ativo foi ocultado dos status. Posteriormente será retrabalhado e voltará a ser exibido
                        <v-flex xs12>
                          <v-switch :label="translate('table.task_category.field.active')"
                                    apv-model="category_fields.active"></v-switch>
                        </v-flex> -->
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <!-- recurrence -->
                <v-flex xs12>
                  <recurrence id="task_recurrence" ref="taskRecurrence" :commitment="editedItem.commitment" :disabled="checkIsFree()" v-if="editedItem.level === 1" :value="editedItem.recurrence" @getRecurrence="(val) => {recurrenceChangeProcess(val)}" :recurrenceText="recurText" ></recurrence>
                </v-flex>
                <!-- note -->
                <v-flex xs12>
                  <v-textarea id="task_note" :key="forceAutoGrow" @keyup.native.ctrl.enter="saveEdit()" maxlength="10000" counter="10000" rows="2" :label="translate('table.' + entity + '.field.note')" name="note" required v-model="editedItem.note" auto-grow >
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <!--Campos personalizados-->
          <!-- // v-show usado pois so mostra os campos personalizados se existir campos personalizados -->
          <!-- v-if pois estava chamando uma vez sem precisar -->
          <v-flex xs12 sm4 v-if="view >= 2" v-show="qtdCustomFields > 0" style="border: 2 0 0 0 #cecece;">
            <!-- // template_id usa o template_id da tarefa pois ele armazena exatamente qual modelo a tarefa veio até das sub modelos -->
            <p-custom-field ref="PCustomField" :origin_field_name="'task_id'" :task_id="editedItem['id']" :tasktemplate_id="editedItem['template_id']"  @closeFieldEditing="closeFieldEditing" :originView="view" @qtdCustomFields="changeQtdCustomFields" :task_shared="shared" :crud_access="editedItem['crud_access']"></p-custom-field>
          </v-flex>
        </v-layout>
        <!-- Detalhes -->
        <v-progress-linear v-if="loading_values" :indeterminate="true"></v-progress-linear>
        <v-flex v-else-if="view == 4" xs12>
          <v-tabs dark color="primary" v-model="tab" fixed-tabs>
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab id="task_comment_tab" href="#0" v-if="checkPlanAccess('task_comment', 'active')">
              {{this.translate('table.task_comment.title')[1]}}
              <v-badge v-if="comments_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{comments_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_files_tab" href="#1" v-if="checkPlanAccess('task_file', 'active')">
              {{this.translate('table.files.title')[1]}}
              <v-badge v-if="files_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{files_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_subtask_tab" href="#2">
              {{this.translate('table.tasks.field.all_subtasks')}}
              <v-badge v-if="editedItem['subtasks_clean_count'] > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{editedItem['subtasks_clean_count']}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_checklist_tab" href="#3" v-if="checkPlanAccess('task_checklist', 'active')">
              {{this.translate('table.task_checklist.title')[1]}}
              <v-badge v-if="checklists_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{checklists_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_reminder_tab" href="#4" v-if="checkPlanAccess('task_reminder', 'active')">
              {{this.translate('table.task_reminder.title')[1]}}
              <v-badge v-if="reminders_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{reminders_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_duration_tab" href="#5" v-if="checkPlanAccess('task_duration', 'active')">
              {{this.translate('table.task_duration.title')[1]}}
              <v-badge v-if="durations_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{durations_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_user_tab" href="#6" v-if="checkPlanAccess('task_user', 'active') && editedItem.level === 1">
              {{this.translate('table.task_user.title')[1]}}
              <v-badge v-if="users_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{users_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_calendar_tab" href="#7" v-if="checkPlanAccess('task_calendar', 'active')">
              {{this.translate('table.task_calendar.title')[1]}}
              <v-badge v-if="calendar_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{calendar_length}}</span>
              </v-badge>
            </v-tab>
            <v-tab id="task_activity_log_tab" href="#8" v-if="!shared && checkPlanAccess('activity_log', 'active')" :disabled="!checkPlanAccess('activity_log', 'has')">
              {{this.translate('table.activity_log.title')[1]}}
              <v-badge v-if="log_length > 0" class="badge" color="#039BE5" right>
                <span slot="badge">{{log_length}}</span>
              </v-badge>
            </v-tab>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item key="0" value="0" v-if="checkPlanAccess('task_comment', 'active')">
                <v-card>
                  <v-card-text>
                    <comment :tab="tab" @itemsLength="val => comments_length = val" :task="editedItem" :task_shared="shared"></comment>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="1" value="1" v-if="checkPlanAccess('task_file', 'active')">
                <v-card>
                  <v-card-text>
                    <file @itemsLength="val => files_length = val" :task="editedItem" :task_shared="shared"></file>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="2" value="2">
                <v-card>
                  <v-card-text>
                    <task-subtask v-if="tab == 2" ref="taskSubtask" :task="editedItem" :task_shared="shared" @editSubItem="(item) => { selectTask(item.id, shared, true, item) }" @doneNewSubtask="doneNewSubtask" @deleteItem="deleteItem" @itemsLength="val => editedItem['subtasks_clean_count'] = val" @statusChanged="statusChanged"></task-subtask>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="3" value="3" v-if="checkPlanAccess('task_checklist', 'active')">
                <v-card>
                  <v-card-text>
                    <checklist :tab="tab" @itemsLength="val => checklists_length = val" :task="editedItem" :task_shared="shared"></checklist>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="4" value="4" v-if="checkPlanAccess('task_reminder', 'active')">
                <v-card>
                  <v-card-text>
                    <reminder @itemsLength="val => reminders_length = val" :task="editedItem" :task_shared="shared"></reminder>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="5" value="5" v-if="checkPlanAccess('task_duration', 'active')">
                <v-card>
                  <v-card-text>
                    <duration @itemsLength="val => durations_length = val" :task="editedItem" :task_shared="shared"></duration>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="6" value="6" v-if="checkPlanAccess('task_user', 'active') && editedItem.level === 1">
                <v-card>
                  <v-card-text>
                    <!-- $auth.check() usado para tarefa compartilhada -->
                    <task-user @itemsLength="val => users_length = val" :task="editedItem" :task_shared="shared"></task-user>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="7" value="7" v-if="checkPlanAccess('task_calendar', 'active')">
                <v-card>
                  <v-card-text>
                    <calendar @itemsLength="val => calendar_length = val" :task="editedItem" :task_shared="shared"></calendar>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="8" value="8" v-if="checkPlanAccess('activity_log', 'active')">
                <v-card>
                  <v-card-text>
                    <!-- Foi incluido o v-if para recarregar o historico sempre que entra na aba, para assim ficar atualizado -->
                    <log v-if="!shared && tab == 8" @itemsLength="val => log_length = val" :task_id="editedItem.id"></log>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>

      </v-card-text>
      <v-layout class="fab-container" align-center>
      <!-- //  loading_users inserido no loading para quando estiver carregando os usuários da equipe, não deixar salvar até terminar para n salvar usuário como responsável em equipes que eles n participam -->
        <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
          <v-tooltip left slot="activator">
            <v-btn  id= "task_save_manage_btn" v-model="fab" slot="activator" fab color="primary" :loading="loading || loading_users" dark @click="saveEdit()">
              <v-icon>{{this.translate('system.button.save.icon')}}</v-icon>
              <v-icon>{{this.translate('system.button.build.icon')}}</v-icon>
            </v-btn>
            <span>{{this.translate('system.button.save_manage.title')}}</span>
          </v-tooltip>

          <v-tooltip left>
            <v-btn id= "task_save_close_btn" slot="activator" fab small color="accent" :loading="loading || loading_users" @click="save()">
              <v-icon>{{this.translate('system.button.save_close.icon')}}</v-icon>
            </v-btn>
            <span>{{this.translate('system.button.save_close.title')}}</span>
          </v-tooltip>

          <v-tooltip left>
            <v-btn  id= "task_save_new_btn" slot="activator" fab small color="secondary" :loading="loading || loading_users" @click="saveNew()">
              <v-icon>{{this.translate('system.button.save_new.icon')}}</v-icon>
            </v-btn>
            <span>{{this.translate('system.button.save_new.title')}}</span>
          </v-tooltip>
        </v-speed-dial>

        <v-tooltip top>
          <v-btn id= "task_close_btn" slot="activator" fab small @click="close">
            <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.close.title')}}</span>
        </v-tooltip>
      </v-layout>
    </v-card>
  </div>
</template>
<style scoped>
  .card-task {
    background-color:#fafafa;
    box-shadow: rgba(63, 63, 63, 0.418) 0px 0px 10px 0px;
    /* <!-- box-shadow: rgb(206 206 206) 1px 1px 1px --> */
    margin-left: 10px;
  }

  .btn-close-edit {
    /* margin-top: 4px; */
    /* margin-bottom: 0; */
    position: relative;
    right: 25px;
  }

  .btn-close-edit-mobile {
    /* margin-top: 4px; */
    /* margin-bottom: 0; */
    position: relative; 
    right: 35px;
  }
  
  .show-edit-border {
    cursor: pointer;
    min-height: 50px;
    border-radius: 5px;
    /* border-style: dashed; */
    border: 1px solid;
    padding-left: 5px;
    padding-right: 8px;
  }

  .show-edit {
    min-height: 50px;
    /* border-style: dashed; */
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0);
    padding-left: 5px;
  }
/* ----------Incio Tela de gerenciamento--------------- */
  .p-gradient {
    background-image: linear-gradient(to bottom right, #56bd89 0%, #3d92cf 100%); /* the gradient */
    padding: 5px;
  }

  .p-label {
    font-size: 9pt;
    color: #1d1d1d;
    font-weight: 600;
  }

  .p-content-id-text {
    font-size: 13pt;
    font-weight: 600;
  }

  .p-content-task {
    font-size: 12pt;
    /* font-weight: 600; */
  }

  .p-content-task-empty {
    font-size: 10pt;
    color: #96989A;
    /* font-weight: 600; */
  }

  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
/* ----------Fim Tela de gerenciamento--------------- */
  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
  .badge {
    padding-right: 15px;
    padding-bottom: 10px;
  }
  .check-commitment {
    position: absolute;
    top: 40px;
  }
  /* .duration-commitment {
    position: absolute;
    right: 5px;
    top: 63px;
  }
  .task-dates {
    position: relative;
  } */
</style>
<script>
  import methodTaskSocket from './../../mixin/methodTaskSocket'
  import socket from './../../mixin/socket'
  import crud from './../../mixin/crud'
  import stopWatch from './../../mixin/stopWatch'
  import rules from './../../mixin/rules'
  import access from './../../mixin/access'
  import tooltip from './../../mixin/tooltip'
  import TaskSubtask from './../details/TaskSubtask'
  import Checklist from './../details/TaskChecklist'
  import Comment from './../details/TaskComment'
  import Duration from './../details/TaskDuration'
  import Calendar from './../details/TaskCalendar'
  import Recurrence from './../details/Recurrence'
  import File from './../details/TaskFile'
  import Reminder from './../details/TaskReminder'
  import Log from './../details/TaskLog'
  import TaskUser from './../details/TaskUser'
  import PDateTime from './../shared/PDateTime'
  import PDate from './../shared/PDate'
  import PConfirm from './../shared/PConfirm'
  import PDependency from './../shared/PDependency'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  import PSelectModalEditable from './../shared/PSelectModalEditable'
  import PSelectEditable from './../shared/PSelectEditable'
  import PShareTask from './../shared/PShareTask'
  import PEditBtn from './../shared/PEditBtn'
  import Swatches from 'vue-swatches'
  import PSelectUser from './../shared/PSelectUser'
  import PSelect from './../shared/PSelect'
  import PSelectStatus from './../shared/PSelectStatus'
  import PTaskDates from './../shared/PTaskDates'
  import PViewClient from './../shared/PViewClient'
  import PCustomField from './../shared/PCustomField'
  import PDocumentPreview from './../shared/PDocumentPreview'

  momentDurationFormatSetup(moment)
  /* eslint-disable eqeqeq, key-spacing, comma-spacing */
  export default {
    mixins: [crud, stopWatch, socket, methodTaskSocket, access, rules, tooltip],
    components: {PSelect, PSelectUser, PEditBtn, PShareTask, Recurrence, Swatches, Log, PSelectEditable, PSelectModalEditable, Checklist, TaskSubtask, Comment, Duration, Calendar, PDependency, File, Reminder, TaskUser, PDateTime, PDate, PConfirm, PSelectStatus, PTaskDates, PViewClient, PCustomField, PDocumentPreview},
    props: ['task_id', 'value', 'fatherView', 'taskFullscreen'],
    data: () => ({
      // forceAutoGrow serve para força o auto-grow quando a tela diminui por causa dos campos personalizados
      forceAutoGrow: false,
      // qtdCustomFields armazena a quantidade de campos personalizados
      qtdCustomFields: 0,
      // isOtherPage usado quando a tarefa está em um link particular, exemplo: compartilhamento da tarefa ou usar o link proprio da tarefa
      isOtherPage: false,
      showMoreFields: true,
      loading_users: false,
      // loading_values criado para quando estiver carregando os valores do gerenciamento tirar os detalhes para que não de erro por não terem valores
      loading_values: false,
      selectedUser: null,
      recurDialog: false,
      deleteRecur: null,
      dialog_password: false,
      task_password: '',
      shared: false,
      log_length: 0,
      calendar_length: 0,
      checklists_length: 0,
      reminders_length: 0,
      durations_length: 0,
      comments_length: 0,
      users_length: 0,
      files_length: 0,
      dependency_length: {total: 0, color: ''},
      dependencyMenu: false,
      // commitment variavel criada pois o check de compromissosorecebe valor depois que salva as datas
      commitment: false,
      // fieldEditing identifica e gerencia qual o campo que está em edição
      fieldEditing: {task_id_text: false, task_team_id: false, task_user_id: false, task_client_id: false, task_urgency: false, task_category_id: false, task_status_id: false, task_dates: false, task_recurrence: false, task_note: false, task_identifier: false},
      defaultFieldEditing: {task_id_text: false, task_team_id: false, task_user_id: false, task_client_id: false, task_urgency: false, task_category_id: false, task_status_id: false, task_dates: false, task_recurrence: false, task_note: false, task_identifier: false},
      deleteFiles: null,
      deletedItem: {},
      filesDialog: false,
      status_fields: {id_text: '', active: true, color: '', identifier: null},
      category_fields: {id_text: '', active: true, color: ''},
      entity: 'tasks',
      task_status: [],
      teams: [],
      selectedBoard: {
        id: '',
        task_template_id: null,
        properties: {task_template_id:'',exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:'',end_period:'',created_by:'',sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true}
      },
      recurText: '',
      users: [],
      mountDepend: false,
      itemFather: {},
      recurrenceText: '',
      participants: [],
      tasktemplate: null,
      tasktemplates: [],
      currentManageRoom: '',
      type: 'task_category',
      menu_begin: false,
      sons: [],
      tab: null,
      fab: null,
      valid: false
    }),
    created () {
      this.initializeCreate()
    },
    methods: {
      // initializeCreate criado pois é necessário chamar no watch quando as rotas é para outra tarefa
      initializeCreate () {
        this.editedItem = {identifier: '', user_id: null, user: null, tasktemplate_id: null, user_index: null, connection_id: null, connection: null, connection_company_id: null, connection_company: null, team_id: null, team: null, category_id: null, category: null, client_id: null, client: null, task_status_id: null, status: null, id_text: null, begin: null, end: null, urgency: null, note: null, recurrence: {type: '', id_text: {each: '', days: '', months: ''}}, password: null, shared: false, sons: [], identifier_sequence: null, commitment: 0, subtasks_clean_count: 0}
        this.defaultItem = {identifier: '', user_id: null, user: null, user_index: null, tasktemplate_id: null, connection_id: null, connection: null, connection_company_id: null, connection_company: null, team_id: null, team: null, category_id: null, category: null, client_id: null, client: null, task_status_id: null, status: null, id_text: null, begin: null, end: null, urgency: null, note: null, recurrence: {type: '', id_text: {each: '', days: '', months: ''}}, password: null, shared: false, sons: [], identifier_sequence: '', commitment: 0, subtasks_clean_count: 0}
        // Quando a tarefa é compartilhada
        this.shared = false
        if (this.$route.path.includes('task_shared')) {
          this.shared = true
        }
        // Verifica a tab ára já abri-la quando carregar, usado no bloco d enotas, que da pra adicionar comentário ou listagem
        if (this.$route.query['tab']) {
          this.tab = this.$route.query['tab']
        }
        if (this.$route.params.id) { // Quando entra na tarefa pelo link sem ser compartilhado
          this.isOtherPage = true
          // Já manda direto pra tela de gerenciamento
          this.selectTask(this.$route.params.id, this.shared, true)
        }
      },
      confirmPassword () {
        if (this.$route.params.id) { // Quando entra na tarefa pelo link sem ser compartilhado
          // Já manda direto pra tela de gerenciamento
          this.selectTask(this.$route.params.id, this.shared)
          this.dialog_password = false
        }
      },
      beforeReloadPageModules (item) {
        let response = false
        for (var prop in item.delTask) {
          if (item.delTask[prop] === this.$auth.user().id) {
            response = true
          }
        }
        return response
      },
      setEnd () {
        this.editedItem.end = moment(this.editedItem.begin).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss')
      },
      getRecurrenceText () {
        if (!this.editedItem.recurrence || this.editedItem.recurrence.type === '') {
          this.recurText = ''
        } else if (this.editedItem.recurrence.type === 'Semanal') {
          this.recurText = `Criar todo(a) ${this.editedItem.recurrence.id_text.days ? this.dateStringToInt(this.editedItem.recurrence.id_text.days) : '        '} a cada ${this.editedItem.recurrence.id_text.each ? this.editedItem.recurrence.id_text.each : '       '} semana(s).`
        } else if (this.editedItem.recurrence.type === 'Diária') {
          this.recurText = `Criar ${this.editedItem.recurrence.id_text.daysToCreate ? this.editedItem.recurrence.id_text.daysToCreate : ''} dia(s) antes da data prevista, com previsão para a cada ${this.editedItem.recurrence.id_text.each ? this.editedItem.recurrence.id_text.each : ''} dia(s)`
        } else if (this.editedItem.recurrence.type === 'Mensal') {
          this.recurText = `Criar a Todo dia ${this.editedItem.recurrence.id_text.days ? this.editedItem.recurrence.id_text.days : ''} a cada ${this.editedItem.recurrence.id_text.each ? this.editedItem.recurrence.id_text.each : ''} Mês(es).`
        } else if (this.editedItem.recurrence.type === 'Anual') {
          this.recurText = `Criar a Todo dia ${this.editedItem.recurrence.id_text.days ? this.editedItem.recurrence.id_text.days : ''} de ${this.editedItem.recurrence.id_text.months ? this.translate('value.months').find(val => {
            return val.value === this.editedItem.recurrence.id_text.months
          }).text : ''} a cada ${this.editedItem.recurrence.id_text.each ? this.editedItem.recurrence.id_text.each : ''} Ano(s).`
        }
      },
      recurrenceChangeProcess (val) {
        this.editedItem.recurrence = val
        this.getRecurrenceText()
      },
      changeOrderSequence (values) {
        if (!values) {
          return []
        } else if (values['tree_task_sequence'] === null) {
          return [values.id]
        } else {
          let order = this.changeOrderSequence(values['tree_task_sequence'])
          order.push(values.id)
          return order
        }
      },
      changeClientNull () {
        this.editedItem.client_id = null
        this.editedItem.client = null
      },
      confirmDialog () {
        // O dialog de confirmação é utilizado em dois momentos (para confirmação de inserção de Tarefa e para confirmação de exclusão)
        if (this.view === 2) {
          // Se a confirmação for gerada a partir da tela de inclusão, é para confirmar se o usuário deseja adicionar Tarefa (a partir de modelo de tarefa com Lembretes) sem Previsão preenchida
          // O viewAfterSave foi guardado no confirmViewAfterSave
          this.save(this.confirmViewAfterSave, true)
        } else {
          // Se a confirmação for gerada a partir da tela de consulta, é para confirmar se o usuário deseja mesmo excluir o item
          this.deleteItem()
        }
      },
      filesDialogEnter (item = JSON.parse(JSON.stringify(this.editedItem))) {
        this.deletedItem = item
        this.filesDialog = true
      },
      deleteFileProcess (del) {
        this.deleteFiles = del
        this.deleteItem(this.deletedItem)
        this.filesDialog = false
      },
      cancelFileProcess () {
        this.deleteFiles = null
        this.deleteRecur = null
        this.filesDialog = false
        this.dialogConfirm = false
      },
      recurDialogEnter (item = JSON.parse(JSON.stringify(this.editedItem))) {
        this.deletedItem = item
        this.recurDialog = true
      },
      deleteRecurProcess (del) {
        this.deleteRecur = del
        this.deleteItem(this.deletedItem)
        this.recurDialog = false
      },
      cancelRecurProcess () {
        this.deleteFiles = null
        this.deleteRecur = null
        this.recurDialog = false
        this.dialogConfirm = false
      },
      // complementItem, serve pra quando terá algum item que será adicionado de complemento, no caso dos itens do board por exemplo
      createTask () {
        // propertiesAddTask faz a verificação para buscar os dados para já preprencher na inclusão de tarefas
        this.$store.dispatch('selectedBoard/propertiesAddTask').then((response) => {
          // Quando seleciona para criar uma tarefa busca os valores do selectedBoard['properties'] pois ele precisa ser atualizados para buscar os valores nos campos da criação
          this.selectedBoard = this.$store.getters[`selectedBoard/values`]
          // Quando estava carregando estava aparecendo consulta, o view faz aparecer Inclusão
          this.view = 2
          // Caso tenha tarefa modelo no filtro, (array ou apenas integer), busca a lista de tarefas modelo de acordo com os modelos do filtro
          if ((Array.isArray(this.selectedBoard['properties']['task_template_id']) && this.selectedBoard['properties']['task_template_id'].length > 0) || (!Array.isArray(this.selectedBoard['properties']['task_template_id']) && this.selectedBoard['properties']['task_template_id'] > 0)) {
            this.$http.get(`api/get_tasktemplate_team?tasktemplate_id=${this.selectedBoard['properties']['task_template_id']}`).then(res => {
              this.tasktemplates = res.body
              // caso so tenha vindo uma tarefa modelo, inclui ela no campo de tarefa modelo
              if (res.body.length === 1) {
                this.tasktemplate = res.body[0]
                // insere os valores no tasktemplate pois quando tem tarefa os valores que estão na area de trabalho devem sobrepor os valores da tarefa modelo
                Object.assign(this.tasktemplate, response.values)
              }
              this.createTaskProcess(response)
            })
          } else {
            this.$http.get(`api/get_tasktemplate_team`).then(res => {
              this.tasktemplates = res.body
            })
            this.createTaskProcess(response)
          }
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      },
      createTaskProcess (response) {
        Object.assign(this.defaultItem, {
          top_id: null,
          task_id: null,
          // company_id usado para no momento de comparar a empresa do editeditem com a empresa logada para habilitar o campo de equipes
          company_id: this.$auth.user().company_id,
          level: 1
        }, response.values)
        // caso tenha algum cliente significa que veio dos quadros, portanto deve vir em formato de array
        if (this.defaultItem['client_id']) {
          this.defaultItem['client_id'] = [this.defaultItem['client_id']]
        }
        if (this.defaultItem['team_id']) {
          this.getUsersTeam(this.defaultItem['team_id'])
        }
        this.create()
        // Caso não tenha user_id e seja uma tarefa da propria empresa inclui a propria pessoa. O user_id pode vir de tarefas modelos
        this.mountOwnReponsible()
        // Zera as validações para já não vir preenchido de vermelho
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 1500)
        // O loader false usado para tirar o loader quando vem o salvar e novo
        this.$store.commit('loader/change_dialog', false)
      },
      afterCreate () {
        // Caso a inclusão possua um modelo de tarefa e o usuário va em salvar e novo ou o quadro esteja vinculado a uma tarefa modelo deve incluir os dados do modelo de tarefa
        if (this.tasktemplate) {
          this.changeTasktemplate(this.tasktemplate)
        }
      },
      createSubItemProcess (item) {
        // Quando estava carregando estava aparecendo consulta, o view faz aparecer Inclusão
        this.view = 2
        this.$store.commit('loader/change_dialog', true)
        // Se tiver ido em salvar e novo em uma tarefa filha pegar o mesmo itemFather
        this.itemFather = (item === null ? this.itemFather : item)
        this.getUsersTeam(this.itemFather.team_id)
        this.createSubItem(this.itemFather)
        this.mountOwnReponsible()

        this.$store.commit('loader/change_dialog', false)
      },
      createSubItem: function (item) {
        // no create da tela de inclusão zera os arquivos que estao a espera para ser adicionados caso tenha. Pois pode ocorrer do usuário adicionar um arquivo porem naõ salvar a tarefa ou sair e já ir pra adição de outro. Exemplo add uma sub e incluir um arquivo, depois clicar para add outra sem ter finalizado a primeira
        this.$store.commit('customField/close_files')
        this.defaultItem = {
          top_id: item.top_id || item.id,
          task_id: item.id,
          team_id: item.team_id,
          client_id: item.client_id,
          // Company_id é passado caso seja uma subtarefa de uma tarefa de uma conexão
          company_id: item.company_id,
          tasktemplate_id: item.tasktemplate_id,
          level: item.level + 1,
          recurrence: {type: '', id_text: {each: '', days: '', months: ''}}
        }
        this.create()
      },
      changeTasktemplate (val) {
        // ao mudar uma tarefa modelo zera os arquivos que estao a espera para ser adicionados caso tenha.
        this.$store.commit('customField/close_files')
        if (val) {
          let value = JSON.parse(JSON.stringify(val))
          if (value.client_id) {
            value.client_id = [value.client_id]
          }
          Object.assign(this.editedItem, value)
          this.editedItem.tasktemplate_id = value.id
          this.editedItem.top_id = null
          this.editedItem.identifier = null
          this.$refs.form.resetValidation()
          let userIndex = null
          if (this.editedItem.user_id) {
            userIndex = {
              company_id: this.editedItem.connection_company_id ? this.editedItem.connection_company_id : this.editedItem.company_id,
              company_id_text: this.editedItem.connection_company ? this.editedItem.connection_company.id_text : this.editedItem.company.id_text,
              connection_id: this.editedItem.connection_id,
              email: this.editedItem.user.email,
              id: `${this.editedItem.user_id}-${this.editedItem.connection_company_id ? this.editedItem.connection_company_id : this.editedItem.company_id}`,
              id_text: `${this.editedItem.user.id_text} (${this.editedItem.user.email})`,
              logo_path: this.editedItem.connection_company ? this.editedItem.connection_company.logo_path : this.editedItem.company.logo_path,
              photo_path: this.editedItem.user.photo_path,
              user_id: this.editedItem.user_id,
              connection_status: 2
            }
            this.selectedUser = userIndex
          }
          // coloca o usuário da modelo de tarefa, se não tiver coloca o usuário que já estava que provavelmente era o proprio usuário
          this.changeResponsible(this.selectedUser)

          if (this.editedItem.team_id) {
            this.getUsersTeam(this.editedItem.team_id)
          }
        } else {
          // insere o level para não sumir o dropbox das tarefas modelo
          Object.assign(this.editedItem, {level: 1}, JSON.parse(JSON.stringify(this.defaultItem)))
          // É buscado o userIndex do usuário conectado para pré-preencher usuário da tarefa
          let userIndex = this.users.find((user) => {
            return ((user.user_id === this.$auth.user().id) && (user.connection_company_id === null))
          })
          if (userIndex) {
            this.changeResponsible(userIndex.id)
          }
          this.$refs.form.resetValidation()
        }
        // ao alterar a tarefa modelo recarrega os campos personalizados, coloca o tasktemplate_id pois deve buscar os registros da tarefa modelo considerando o value, insere o originView = 0 para cair no else buscar os valores do banco normalmente
        if (this.$refs.PCustomField) this.$refs.PCustomField.getCustomFields('tasktemplate_id', -1, val ? val['id'] : 0, 0)
      },
      afterEditSocketManagementDetails (item) {
        if (item.values.user_id) {
          let userIndex = {
            company_id: item.values.connection_company_id ? item.values.connection_company_id : item.values.company_id,
            company_id_text: item.values.connection_company ? item.values.connection_company.id_text : item.values.company.id_text,
            connection_id: item.values.connection_id,
            email: item.values.user.email,
            id: `${item.values.user_id}-${item.values.connection_company_id ? item.values.connection_company_id : item.values.company_id}`,
            id_text: `${item.values.user.id_text} (${item.values.user.email})`,
            logo_path: item.values.connection_company ? item.values.connection_company.logo_path : item.values.company.logo_path,
            photo_path: item.values.user.photo_path,
            user_id: item.values.user_id,
            connection_status: 2
          }
          if (userIndex) {
            this.selectedUser = userIndex
            this.changeResponsible(userIndex)
          }
        }
        // Verifica se tem equipe e se não é de uma tarefa compartilhada, pois se for de tarefa compartilhada não precisa buscar a lista de usuários
        if (item.values.team_id && !this.shared) {
          this.getUsersTeam(item.values.team_id)
        }
      },
      dialogDelete (item) {
        this.dialogConfirm = true
        // this.$emit('dialogDelete', items)
        this.editedItem = item
      },
      dateStringToInt (item) {
        var arr = []
        // ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
        item.forEach(val => {
          switch (val) {
            case 0:
              arr.push(' Domingo')
              break
            case 1:
              arr.push(' Segunda')
              break
            case 2:
              arr.push(' Terça')
              break
            case 3:
              arr.push(' Quarta')
              break
            case 4:
              arr.push(' Quinta')
              break
            case 5:
              arr.push(' Sexta')
              break
            case 6:
              arr.push(' Sábado')
              break
          }
        })
        return arr
      },
      // Criado editedItem armazenar os valores, pois durante a exclusão o this.editeItem perde os valores, definido no parametro pois é usado também na consulta da task
      deleteItem (editedItem = JSON.parse(JSON.stringify(this.editedItem))) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.delete(`api/${this.entity}/${editedItem.id}?${this.deleteFiles === null ? '' : 'delete=' + this.deleteFiles}${this.deleteRecur === null ? '' : '&deleteRecur=' + this.deleteRecur}`).then(
          (res) => {
            // Methodo com socket ao deletar uma tarefa
            this.methodDeleteTaskSocket(res.body)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' excluído com sucesso!', color: 'success', dialog: true})
            // Verifica se tem o from_tasks pois se tiver significa que é um item da aba de subtarefas do gerenciamento de tarefas que o processo deve ser diferente
            if (editedItem.hasOwnProperty('from_task') && editedItem['from_task']) {
              this.$refs.taskSubtask.deleteExecuteProcess(editedItem.id)
              // from_task caso tenha o from_task joga ele no res.body para ser passao no emit do deleteExecute
              res.body['from_task'] = editedItem['from_task']
            } else {
              // depois que exclui vai para tela de retorno
              if (this.$route.query.return) {
                this.$router.push(`/${this.$route.query.return}`)
              } else if (this.$route.params.id) {
                this.$router.push('/home')
              }
              if (this.view === 4) this.close()
              this.closeDialogDelete()
            }
            this.$emit('deleteExecute', res.body)
            this.deleteFiles = null
            this.deleteRecur = null
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            if (err.body.message === 'notFoundTask') {
              this.deleteRecur = null
              this.deleteFiles = null
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível deletar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
            } else if (err.body.message === 'actionDenied') {
              this.deleteRecur = null
              this.deleteFiles = null
              this.$store.commit('snackbar/change_values', {text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem excluir-la.', color: 'warning', dialog: true})
            } else if (err.body.message === 'hasFile') {
              this.filesDialogEnter(editedItem)
            } else if (err.body.message === 'hasRecurrence') {
              this.recurDialogEnter(editedItem)
            } else {
              this.deleteRecur = null
              this.deleteFiles = null
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível deletar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
            }
          })
      },
      // props task usada para já preencher os valores no front
      selectTask (taskId, shared = false, changeSons = false, task = null) {
        //* Insere o usuário na sala de acordo com a operação que ele está realizando (editando ou gerenciando tarefa)
        // quando o usuário edita uma subtarefa pela aba de subtarefas no gerenciamento de tarefas, a sala da mãe continua
        if (this.editedItem.hasOwnProperty('id') && this.editedItem['id'] > 0) {
          this.$socket.emit('leaveRoom', {room: `tasks${this.editedItem['id']}_manage`})
        }
        // verifica auth.check por causa de tarefa compartilhada
        // Adicionar o usuário na sala da nova tarefa que foi selecionada
        this.$socket.emit('joinRoom', {room: `tasks${taskId}_manage`, username: this.$auth.check() ? this.$auth.user().id_text : 'Anonimo', view: 4})
        // Quando seleciona para editar uma tarefa busca os valores do selectedBoard['properties'] pois ele precisa ser atualizados para buscar os valores nos campos da edição
        this.selectedBoard = this.$store.getters[`selectedBoard/values`]
        // Armazena valor do editedItem pois se der errado ao carregar retorna pra ele
        let editedItemAux = this.editedItem
        if (task) {
          this.editedItem = JSON.parse(JSON.stringify(task))
        } else {
          this.$store.commit('loader/change_dialog', true)
        }
        this.mountDepend = false
        // Quando estava carregando estava aparecendo consulta, o view faz aparecer Gerenciamento
        this.view = 4
        this.loading_values = true
        this.$http.get(`api/${shared === true ? 'task_shared' : 'tasks'}/${taskId}?${shared === true ? 'shared=true' : ''}${this.task_password !== '' ? '&password=' + btoa(this.task_password) : ''}`).then(res => {
          // Caso seja a primeira vez que o usuário entra em uma tarefa compartilhada ou a senha do uusário esteja errada, solicita que o usuário coloque a senha novamente
          if (res.bodyText === 'invalid_password') {
            this.dialog_password = true
            this.task_password = ''
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Favor inserir uma senha valida.', color: 'warning', timeout: 6000, dialog: true})
            return ''
          }
          // Caso o usuário entre com um link de compartilhamento e ele tenha mais acesso que o normal muda o link de acesso dele
          if (res.bodyText === 'change_link') {
            this.$router.push(`/task/${taskId}`)
            return ''
          }
          // Caso o usuário entre com um link não compartilhado e ele não tenha acesso muda o link para o public
          if (res.bodyText === 'change_link_to_public') {
            this.$router.push(`/task_shared/${taskId}`)
            return ''
          }
          let taskItem = JSON.parse(JSON.stringify(res.body))
          // verifica se o usuário tem acesso aquela tarefa, se ele não tiver acesso o res.body vira false
          if (!taskItem) {
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Você não participa dessa tarefa.', color: 'warning', timeout: 6000, dialog: true})
            this.$router.push(`/access-denied`)
          }
          // quando recurrence vazio inicializa a variavel
          if (taskItem.recurrence === null) {
            taskItem.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
          }
          // this.changeTeam(taskItem.team_id)
          this.editItem(taskItem, 4)
          // this.$emit('changeModal', true)
          // this.$refs.form.resetValidation()
          this.$store.commit('loader/change_dialog', false)
          // Devido a grande quantidade de front, estava bugando quando apertava rapido para fechar
          setTimeout(() => {
            this.loading_values = false
          }, 500)
          this.mountDepend = true
          if (changeSons) {
            this.sons = this.editedItem.sons
          }
          // Carrega os registros de dependencia
          // se for tarefa compartilahda não carrega as dependencias
          if (!shared) this.$refs.taskDependency.reloadDependencies(true, this.editedItem['id'])
        },
        err => {
          if (err.body.message === 'notFoundTask') {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível acessar a tarefa. Verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível acessar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', timeout: 6000, dialog: true})
          }
          console.log(err)
          this.editedItem = editedItemAux
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          if (this.$route.query.return) {
            this.$router.push(`/${this.$route.query.return}`)
          } else if (this.$route.params.id) {
            this.$router.push('/home')
          } else {
            // caso de algum erro fecha a tela de gerenciamento
            this.close()
          }
        })
      },
      // doneNewSubtask usado quando o usuário inclui uma tarefa rapida ou duplica uma tarefa pela aba de subtarefas do gerenciamento de tarefas
      doneNewSubtask (item) {
        this.$emit('savePost', item, 4.5)
        // Metodo para adicionar tarefas por socket em todos os lugares necessários
        this.methodAddTaskSocket(item)
      },
      // doneNewTask usando quando o usuário clica pra confirmar a inclusão rápida de uma tarefa.
      // também Usado no refs do task
      doneNewTask (val) {
        this.view = 2
        this.editedItem = val
        setTimeout(() => {
          this.save(1, false, false, false)
          // Apos salvar abre novamente para adicionar tarefa
        }, 200)
      },
      /* O parâmetro confirm foi criado, pois ao tentar Salvar uma Tarefa preenchida por meio de um modelo de tarefa é feita a seguinte verificação:
      Se o modelo de tarefa possuía Lembretes/Reminders e a Tarefa que se utiliza dela não tem Previsão preenchida, o usuário é notificado que caso a Previsão não seja preenchida, aqueles Lembretes do modelo de tarefa não serão incluídos e ele precisa confimar se quer continuar mesmo assim.
      Esse confirma irá abortar a função Salvar, dessa forma, se ele selecionar cancelar, pode alterar normalmente, mas se ele confirmar que quer continuar mesmo assim, é preciso chamar a função Salvar novamente, dessa vez setando a variável confirm como true, sinalizando que aquela mensagem de confirmação já apareceu e o usuário confirmou a ação. Nesse caso, a mensagem não aparecerá mais, e a ação Salvar seguirá normalmente. */
      // validade, parametro para verificar se deve passar pelas validações ou não, pois no adicionar rápido não passa pelas validações, pois tinha campos não preenchidos como o da tarefa modelo que usa outro campo sem ser o do editedItem
      save (viewAfterSave = 1, confirm = false, loading = true, validate = true) {
        if (validate && this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {text: 'Por favor, corrija as validações antes de salvar!', color: 'warning', dialog: true})
          return false
        }
        this.loading = true
        if (loading) this.$store.commit('loader/change_dialog', true)
        if (this.editedItem.commitment === 0) {
          this.editedItem.begin = null
        }
        if (this.view === 2) {
          // Quando for salvar uma tarefa de nivel 1 veriffica se foi selecionar alguma tarefa modelo para inserirr ela
          if (this.editedItem.level === 1) {
            var tempTemplate = this.tasktemplate ? JSON.parse(JSON.stringify(this.tasktemplate)) : null
            // Pega a tarefa modelo da variavel tasktemplate, caso não tenha essa variavel pega o valor que já existe, o tasktemplate_id vem preenchido no editedItem acontece quando o usuario adiciona rapido e o board está vinculado ao
            if (tempTemplate) this.editedItem.tasktemplate_id = tempTemplate.id
          }
          var editedItemStatus = this.task_status.find((val) => { return val.id === this.editedItem.task_status_id })
          if (this.tasktemplate && editedItemStatus) {
            if (editedItemStatus['identifier'] === 3) {
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {text: 'Uma tarefa vinda de um modelo de tarefa não pode iniciar com o status de conclusão!', color: 'warning', dialog: true, timeout: 10000})
              return false
            }
          }
          // Verificação se o modelo de tarefa usada continha Lembretes/Reminders - é feita somente na inserção
          if ((tempTemplate && tempTemplate.has_reminders && (!this.editedItem.end)) && !confirm) {
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            // Salva o valor do  viewAfterSave para que quando a function save for chamada de novo após o confirmar, não cause erro na pós inserção
            this.confirmViewAfterSave = viewAfterSave
            this.dialogConfirm = true
            return false
          }
          // Pega os valores do customField para mandar pra controller para ser tudo adicionado
          let customFields = this.$store.state.customField.values
          if (customFields.length > 0) this.editedItem['customFields'] = customFields
          this.$http.post('api/' + this.entity, this.editedItem).then((res) => {
            let resBody = res.body
            // reloadPage Busca os registros da página de consulta, deve ser feito dentro do post, pois ele estava buscando os registro primeiro que o posto, não vindo o registro adicionado
            // this.$emit('reloadPage')
            // Foi usado o if length para verificar se possui uma tarefa retornada ou nenhuma, para que seja extraido o array ou diretamente.
            if (resBody.length) {
              // armazena o length das tarefas e vai subtraindo até chegar no zero e saber que é a ultima tarefa, não é usado o isLastTask pois dentro do dispatch ele não traz o valor correto
              // let indexTask = resBody.length
              for (var i = 0; i < resBody.length; i++) {
                this.saveInsertFiles(resBody, resBody[i], (i + 1) >= resBody.length, viewAfterSave, loading)
              }
            } else {
              this.saveInsertFiles([resBody], resBody, true, viewAfterSave, loading)
            }
          },
          err => {
            console.log(err)
            if (loading) this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          })
        } else if (this.view === 3) {
          // Se o parametro da empresa de mudar o usuárioo estiver ativo contendo o status, altera o usuário da tarefa para o usuário logado
          let params = JSON.parse(this.$auth.user().company.params)
          // Verfica se o status anterior é diferente do atual
          if (this.beforeEditedItem['task_status_id'] != this.editedItem['task_status_id']) {
            if (params.hasOwnProperty('changeUser') && params['changeUser']['active'] && params['changeUser']['status'].some((value) => { return value == this.editedItem['task_status_id'] })) {
              this.editedItem.user_id = this.$auth.user().id
            }
          }
          // verifica se não existe recorrencia e reajusta o recurrence_id para que haja alteração e crie um log para o historico
          if (!this.editedItem.recurrence || this.editedItem.recurrence.type === '') this.editedItem.recurrence_id = null
          this.$http.put('api/' + this.entity + '/' + this.editedItem.id,
            this.editedItem).then(
            (res) => {
              // taskAux criado para colocar o old_status antigo para atualizar no kanban
              let taskAux = {}
              let beforeTask = this.beforeEditedItem
              Object.assign(taskAux, res.body, {users: res.body.users, old_status: ((beforeTask !== {} && beforeTask.status) ? beforeTask.status : res.body.status)})

              this.$emit('savePut', taskAux, viewAfterSave)
              this.editedItemDB = JSON.parse(JSON.stringify(res.body))
              // Inicia ou para o tempo conforme a edição do status
              if (this.beforeEditedItem['task_status_id'] != this.editedItem['task_status_id']) {
                this.companyParamsTime(res.body)
              }
              if (this.editedItemDB.recurrence === null) this.editedItemDB.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
              // Metodo para adicionar tarefas por socket em todos os lugares necessários
              this.methodEditTaskSocket(res.body, this.beforeEditedItem)
              // se tiver automações de lembretes chama eles
              if (res.body['automations'].length > 0) {
                this.$store.commit('automationMessage/change_values', {dialog: true, taskId: res.body['id'], tasktemplateAutomationIds: res.body['automations']})
              }
              if (!!res.body.before_status_identifier && res.body.status.identifier === 3) {
                // popup para finalização das tasks filhas
                if (res.body['finalize_sons']) {
                  this.$store.commit('snackbarButton/change_values', {
                    text: 'Deseja finalizar as tarefas de níveis abaixo?',
                    color: 'blue',
                    buttonColor: 'blue',
                    buttonText: 'Finalizar subtarefas',
                    buttonFunction: () => {
                      this.$store.commit('snackbarButton/change_values', {dialog: false})
                      this.$http.get(`api/finalize_lower_tasks/${res.body.id}`).then(response => {
                        this.$emit('reloadPage')
                        // Socket para atualizar a subtarefa na tela de gerenciamento de tarefas
                        this.$socket.emit('generalEvent', {
                          data: res.body.id,
                          notBroadcast: true,
                          responseEvent: 'reloadTaskSubTask',
                          room: `tasks${res.body.id}_manage`
                        })
                        this.$store.commit('snackbar/change_values', { text: 'Tarefas filhas finalizadas com sucesso!', color: 'success', dialog: true })
                        if (res.body['finalize_father']) {
                          this.finalizeFather(res.body)
                        }
                      })
                    },
                    dialog: true
                  })
                // popup para finalização da task pai
                } else if (res.body['finalize_father']) {
                  this.finalizeFather(res.body)
                }
                for (var element in res.body.participants) {
                  this.$socket.emit('generalEvent', {
                    data: res.body,
                    responseEvent: 'deleteSocketCalendarTask',
                    room: `calendar${res.body.participants[element]}`
                  })
                }
              }
              // caso haja mudança e o identifier antigo é de finalizado addiciona o via socket a tarefa no calendario
              if (!!res.body.before_status_identifier && res.body.before_status_identifier === 3) {
                for (element in res.body.participants) {
                  this.$socket.emit('generalEvent', {
                    data: res.body,
                    responseEvent: 'addSocketCalendarTask',
                    room: `calendar${res.body.participants[element]}`
                  })
                }
              }
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true})
              this.close()
              this.sons = this.editedItem.sons
            },
            err => {
              console.log(err)
              if (err.body.message === 'notFoundTask') {
                this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
              } else if (err.body.message === 'hasDependency') {
                this.$store.commit('snackbar/change_values', {text: 'Para finalizar essa tarefa, todos os pré-requisitos devem ser finalizados.', color: 'warning', timeout: 10000, dialog: true})
              } else if (err.body.message === 'dependentFinalized') {
                this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
              } else {
                this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
                alert('Erro! Falha ao enviar a requisição.')
              }
              this.loading = false
              this.$store.commit('loader/change_dialog', false)
            }
          )
        }
        if (confirm) {
          this.dialogConfirm = false
        }
      },
      // função criada para auxiliar o save a incluir varios arquvios de varias tarefas
      saveInsertFiles (allTasks, task, isLastTask, viewAfterSave, loading) {
        this.methodAddTaskSocket(task, viewAfterSave)
        // chama para adicionar arquivos caso tenha
        this.$store.dispatch('customField/add_files', {task_id: task['id'], clean_form: isLastTask, save_bd: true}).then((files) => {
          if (Array.isArray(files)) {
            task['files'] = files
            files.forEach(file => {
              // linha utilizada para informar a Tela de Arquivos que este elemento veio da tela de Tarefas
              file['source'] = 2
              // Emitindo evento para adicionar arquivo à tela de arquivos
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'addSocketItem',
                room: `files${file['company_id']}`
              })
            })
          }
          if (isLastTask) {
            this.afterSave(allTasks, task, viewAfterSave)
          }
        }, err => {
          console.log(err)
          if (isLastTask) {
            // Apesar de dar o erro nos arquivos a tarefa já foi adicionada
            this.afterSave(allTasks, task, viewAfterSave)
            // Metodo para adicionar tarefas por socket em todos os lugares necessários
            this.methodAddTaskSocket(task)
            // caso tenha sido barrado porque o plano excedeu o limite, mostra a msg de erro
          }
          if (err.body.message.includes('limit|')) {
            // busca a memoria do plano do usuário
            let sizePlan = this.getterAccesses.find((res) => {
              return (res.id_text === 'files' && res.hasOwnProperty('size'))
            })
            // caso não tenha a variavel de tamanho, insere 0
            sizePlan = !sizePlan ? 0 : sizePlan['size']
            // transforma bit em mb
            let sumSizeFiles = (parseInt(sizePlan) - parseInt(err.body.message.split('|')[1])) / 1000000
            this.$store.commit('dialogPlan/change_values', {
              title: 'Memória excedida',
              text: `Esse arquivo ultrapassa o limite do seu plano, você tem apenas <strong>${Math.round(sumSizeFiles)}mb disponível</strong>. Aproveite e faça o upgrade agora mesmo!`,
              showDialog: true
            })
          } else {
            this.$store.commit('snackbar/change_values', { text: `Ocorreu um erro ao salvar os arquivos reporte o erro!`, color: 'error', dialog: true })
          }
          this.$store.commit('loader/change_dialog', false)
        }).finally(() => {
          if (isLastTask) this.finallySave(loading, viewAfterSave)
        })
      },
      // afterSave função usada depois que salva o(s) registro(s) de tarefa(s)
      // O tasks é necessário apenas quando tem varias tarefas,n ocaso quandos alva com varios clientes
      afterSave (tasks, task, viewAfterSave) {
        if (task.recurrence === null) {
          task.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
        }
        this.$emit('savePost', tasks, viewAfterSave)
        // Inicia ou para o tempo conforme a edição do status
        this.companyParamsTime(task)
        this.editedItemDB = JSON.parse(JSON.stringify(task))
        // Se viewAfterSave for pra ir pra tela de consulta ai da o close para zerar tudo já que os campos personalizados não estavam sendo zerados
        if (viewAfterSave === 1) this.close()
      },
      finallySave (loading, viewAfterSave) {
        if (loading) this.$store.commit('loader/change_dialog', false)
        this.loading = false
        this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
        // Caso a proxima tela sejá diferente de inserir(salvar e novo) zera o tasktemplate
        if (viewAfterSave !== 2) {
          // zera o tasktemplate
          this.tasktemplate = null
        }
        // limpa o defaultItem pois quando é de alguma tarefa filha ele recebe valores da mae e não estavam sendo zerados
        this.defaultItem = {identifier: '', user_id: '', connection_id: null, connection_company_id: null, team_id: '', category_id: '', client_id: '', task_status_id: '', tasktemplate_id: null, id_text: '', begin: '', end: '', urgency: '', note: '', recurrence: {type: '', id_text: {each: '', days: '', months: '', commitment: 0}}}
        this.sons = this.editedItem.sons
        // montar componente de dependencias pois não passa pelo selectTask
        this.mountDepend = true
      },
      // mountOwnReponsible monta o priprio usuário para já preprencher quanod não possui valor
      mountOwnReponsible () {
        // Caso não tenha user_id e seja uma tarefa da propria empresa inclui a propria pessoa. O user_id pode vir de tarefas modelos
        if (!this.editedItem.user_id && this.editedItem.company_id == this.$auth.user().company_id) {
          // É buscado o userIndex do usuário conectado para pré-preencher usuário da tarefa
          let company = this.$auth.user().company
          let user = this.$auth.user()
          let userIndex = {
            company_id: company.id,
            company_id_text: company.id_text,
            connection_id: null,
            email: user.email,
            id: `${user.id}-${user.company_id}`,
            id_text: `${user.id_text} (${user.email})`,
            logo_path: company.logo_path,
            photo_path: user.photo_path,
            user_id: user.id,
            connection_status: 2
          }
          this.changeResponsible(userIndex)
        }
      },
      changeResponsible (val, saveValuesBd = false) {
        // se for salvar no banco, primeiro verifica se existe acesso, exemplo, quando o usuário é apenas parcipante e clica no x para zerar o responsável
        if (saveValuesBd) {
          if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
            this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
            return false
          }
        }
        if (val && val.id !== null && val.id !== {}) {
          this.selectedUser = val
          this.editedItem.user_id = val.user_id
          var companyId = this.editedItem.company_id ? this.editedItem.company_id : this.$auth.user().company_id
          // verifica de onde é a tarefa, pois se for selecionado um usuário da mesma empresa da tarefa o connection_id e o connection_company_id devem ser null
          this.editedItem.connection_id = (val.company_id != companyId ? val.connection_id : null)
          this.editedItem.connection_company_id = (val.company_id != companyId ? val.company_id : null)
        } else {
          this.selectedUser = null
          this.editedItem.user_id = null
          this.editedItem.connection_id = null
          this.editedItem.connection_company_id = null
        }
        if (saveValuesBd) {
          this.editedItem.user = this.selectedUser ? this.selectedUser : {}
          this.fieldEdit({user_id: this.editedItem.user_id, connection_id: this.editedItem.connection_id, connection_company_id: this.editedItem.connection_company_id}, 'task_user_id')
        }
      },
      changeStatus (id = this.editedItem.task_status_id, item = null) {
        // Já atualiza o edited item para o selectItem do componente p-select-editabel ficar atualizado
        Object.assign(this.editedItem, {task_status_id: id, status: item})
        // Se o parametro da empresa de mudar o usuárioo estiver ativo contendo o status, altera o usuário da tarefa para o usuário logado
        let params = JSON.parse(this.$auth.user().company.params)
        // Verfica se o status anterior é diferente do atual
        if (this.beforeEditedItem['task_status_id'] != id) {
          if (params.hasOwnProperty('changeUser') && params['changeUser']['active'] && params['changeUser']['status'].some((value) => { return value == id })) {
            this.editedItem.user_id = this.$auth.user().id
          }
        }
        // Caso tenha o changeUser significa que foi alterado para um status que deve altarar o responsável, portanto alterar o responsável no front
        if (this.editedItem['status'] && (this.editedItem.status['changeUser'])) {
          Object.assign(this.editedItem, this.editedItem.status['changeUser'])
        }
        this.fieldEdit({task_status_id: id, status: item}, 'task_status_id')
      },
      changeTeam (id = this.editedItem.team_id, item = null, saveValuesBd = false) {
        // nos casos de cliente ou equipe verifica se é subtarefa ou se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if (id === null && (this.editedItem['level'] > 1 || this.editedItem['company_id'] != this.$auth.user().company_id)) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possivel editar cliente ou equipe de tarefas filhas ou tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        // se for salvar no banco, primeiro verifica se existe acesso, exemplo, quando o usuário é apenas parcipante e clica no x para zerar a equipe
        if (saveValuesBd) {
          if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
            this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
            return false
          }
        }
        // Atualiza o team para atualizar no front para ser instantaneo para o usuário
        this.editedItem.team = item
        // salva o valor editado no banco
        this.getUsersTeam(id, saveValuesBd)
      },
      // saveValuesBd usado quando o change team vai salvar os valores depois de verificar se o usuário existe ou não
      getUsersTeam (val = this.editedItem.team_id, saveValuesBd = false) {
        if (val) {
          this.loading_users = true
          this.$http.get(`api/get_teams_users_illis/${val}`).then(res => {
            this.users = res.body
            let userId = `${this.editedItem['user_id']}-${this.editedItem['connection_company_id'] ? this.editedItem['connection_company_id'] : this.editedItem['company_id']}`
            let selectedUser = this.users.find((user) => { return user.id === userId })
            this.loading_users = false
            // se o usuário selecionado não estiver na equipe selecionada o campo é limpado
            if (!selectedUser) {
              this.changeResponsible(null)
            }
            if (saveValuesBd) {
              // caso tenha usuário entao apenas salva a equipe ,caso não tenha usuário já zera o campo de usuário tbm
              let values = selectedUser ? {team_id: val} : {team_id: val, user: null, connection_id: null, connection_company_id: null}
              this.fieldEdit(values, 'task_team_id')
            }
          }, err => {
            console.log(err)
            this.loading_users = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros do campo responsável, reporte o erro.', color: 'error', dialog: true})
          })
        } else {
          this.users = []
          // caso não tenha id da equipe então so verifica se é pra salvar o valor no banco, necessário quando limpa a equipe
          if (saveValuesBd) {
            this.fieldEdit({team_id: null}, 'task_team_id')
          }
        }
      },
      clickFieldEditDates () {
        if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // fieldEditing abre antes para acionar o openDates
        this.fieldEditing['task_dates'] = true
        this.$refs.taskDates.openDates()
        this.clickFieldEdit('task_dates')
      },
      clickFieldEditRecurrence () {
        if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // fieldEditing abre antes para acionar o openRecurrence
        this.fieldEditing['task_recurrence'] = true
        setTimeout(() => {
          this.$refs.taskRecurrence.openRecurrence()
          this.clickFieldEdit('task_recurrence')
        }, 100)
      },
      clickFieldEditUser (item = this.editedItem) {
        if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // Monta o usuário pra ficar no formato correto
        if (item.user_id) {
          this.selectedUser = {
            company_id: item.connection_company_id ? item.connection_company_id : item.company_id,
            company_id_text: item.connection_company ? item.connection_company.id_text : item.company.id_text,
            connection_id: item.connection_id,
            email: item.user.email,
            id: `${item.user_id}-${item.connection_company_id ? item.connection_company_id : item.company_id}`,
            id_text: `${item.user.id_text} (${item.user.email})`,
            logo_path: item.connection_company ? item.connection_company.logo_path : item.company.logo_path,
            photo_path: item.user.photo_path,
            user_id: item.user_id,
            connection_status: 2
          }
          this.changeResponsible(this.selectedUser)
        } else {
          this.changeResponsible(null)
        }
        this.clickFieldEdit('task_user_id')
      },
      clickFieldEdit (field) {
        if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // nos casos de cliente ou equipe verifica se é subtarefa ou se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if ((field === 'task_client_id' || field === 'task_team_id') && (this.editedItem['level'] > 1 || this.editedItem['company_id'] != this.$auth.user().company_id)) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possivel editar cliente ou equipe de tarefas filhas ou tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        // CAso seja clicado no campo de datas preenche o campo commitment, pois o v-model do check não pode ser o editedItem pois so pode salvar o valor depois de alterado as datas
        if (field === 'task_dates') {
          this.commitment = this.editedItem['commitment']
        }
        // for para fechar todos os outros campos que eestariam aberto, pois por enquanto não da pra colocar no blur já que o usuário pode fazer outras coisas como editar ou excluir camposigual a categoria ou o status
        for (var property in this.fieldEditing) {
          if (property != field) this.fieldEditing[property] = false
        }
        // Uma das utilidades do beforEditItem é verifica se o valor foi alterado para salvar
        this.beforeEditedItem = JSON.parse(JSON.stringify(this.editedItem))
        // Habilita a edição do filtro
        this.fieldEditing[field] = true
        setTimeout(() => {
          // Devido os campos de datas e recorrencia terem mais funções, eles não são clicados automaticamente
          if (!['task_dates', 'task_recurrence'].includes(field)) document.getElementById(field).click()
        }, 100)
      },
      fieldEdit (values, field) {
        // nos casos de cliente ou equipe verifica se é subtarefa ou se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if ((field === 'task_client_id' || field === 'task_team_id') && (this.editedItem['level'] > 1 || this.editedItem['company_id'] != this.$auth.user().company_id)) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possivel editar cliente ou equipe de tarefas filhas ou tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        // não permite o usuárioe ditar caso não tenha acesso, pode acontecer em momento como quando o usuário é apenas participante e tenta ir no x pra zerar o campo
        if (!this.checkPermission(this.entity, 'edit') || this.shared || !this.editedItem.crud_access) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // Já pega os valores do this.editedItem, pois no momento de salvar o usuário pode solicitar passar pra outra tarefa o que mudaria o editedItem fazendo os valores salvarem na tarefa selecionada depois
        let editedItem = JSON.parse(JSON.stringify(this.editedItem))
        setTimeout(() => {
          if ((this.$refs[field + '_form'] && !this.$refs[field + '_form'].validate())) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'warning',
              dialog: true
            })
            this.editedItem = JSON.parse(JSON.stringify(this.beforeEditedItem))
            return false
          }
          // fields.forEach((field) => { this.fieldEditing[field] = false })
          this.fieldEditing[field] = false
          // verifica se foi alterado algum valor, caso tenha sido alterado, salva.
          // tbm verifica quando o valor é null pois nesse caso foi clicaco no x e no x o beforeEditedItem ainda não recebeu valores sendo null tbm
          let saveValues = false
          for (var prop in values) {
            if (values[prop] != this.beforeEditedItem[prop] || values[prop] === null) {
              saveValues = true
            }
          }
          if (saveValues) this.savePut(values, editedItem)
        }, 100)
      },
      savePut (values, editedItem) {
        // Caso o usuário ainda esteja na mesma tarefa edita os valoers do EditedItem
        // já insere os valores no editedItem para já mostrar alterado no front
        if (this.editedItem['id'] == editedItem['id']) Object.assign(this.editedItem, values)
        // Se o parametro da empresa de mudar o usuárioo estiver ativo contendo o status, altera o usuário da tarefa para o usuário logado
        let params = JSON.parse(this.$auth.user().company.params)
        // Verfica se o status anterior é diferente do atual
        if (this.beforeEditedItem['task_status_id'] != this.editedItem['task_status_id']) {
          if (params.hasOwnProperty('changeUser') && params['changeUser']['active'] && params['changeUser']['status'].some((value) => { return value == this.editedItem['task_status_id'] })) {
            this.editedItem.user_id = this.$auth.user().id
          }
        }
        // Também alterar o editedItem para usar ele durante o processo e garantir que vai permanecer na tarefa editada por amis que o usuário troque de tarefa
        Object.assign(editedItem, values)
        // Insere os valores que sao usados no back para so mandar eles e não tudo, pois no back existem campo necessário do request
        let valuesAux = {
          id: editedItem['id'],
          top_id: editedItem['top_id'],
          task_id: editedItem['task_id'],
          company_id: editedItem['company_id'],
          task_status_id: editedItem['task_status_id'],
          password: editedItem['password'],
          shared: editedItem['shared'],
          identifier: editedItem['identifier'],
          recurrence: editedItem['recurrence'],
          recurrence_id: editedItem['recurrence_id'],
          status_date: editedItem['status_date'],
          create_user_id: editedItem['create_user_id'],
          user_id: editedItem['user_id'],
          team_id: editedItem['team_id']
        }
        values = Object.assign(valuesAux, values)
        // verifica se não existe recorrencia e reajusta o recurrence_id para que haja alteração e crie um log para o historico
        if (!editedItem.recurrence || editedItem.recurrence.type === '') editedItem.recurrence_id = null
        this.$http.put('api/' + this.entity + '/' + editedItem.id, values).then(
          (res) => {
            // atualiza o editedItem
            Object.assign(editedItem, JSON.parse(JSON.stringify(res.body)))
            // Caso o usuário ainda esteja na mesma tarefa edita os valoers do EditedItem, usa o Object.assign para manter os dados dos detalhes
            if (this.editedItem['id'] == editedItem['id']) Object.assign(this.editedItem, JSON.parse(JSON.stringify(res.body)))
            // taskAux criado para colocar o old_status antigo para atualizar no kanban
            let taskAux = {}
            let beforeTask = this.beforeEditedItem
            Object.assign(taskAux, res.body, {users: res.body.users, old_status: ((beforeTask !== {} && beforeTask.status) ? beforeTask.status : res.body.status)})
            this.$emit('savePut', taskAux)
            // Usa o Object.assign para manter os dados dos detalhes
            Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(res.body)))
            // Inicia ou para o tempo conforme a edição do status
            if (this.beforeEditedItem['task_status_id'] != editedItem['task_status_id']) {
              this.companyParamsTime(res.body)
            }
            if (this.editedItemDB.recurrence === null) this.editedItemDB.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
            // Metodo para adicionar tarefas por socket em todos os lugares necessários
            this.methodEditTaskSocket(res.body, this.beforeEditedItem)
            // se tiver automações de lembretes chama eles
            if (res.body['automations'].length > 0) {
              this.$store.commit('automationMessage/change_values', {dialog: true, taskId: res.body['id'], tasktemplateAutomationIds: res.body['automations']})
            }
            if (!!res.body.before_status_identifier && res.body.status.identifier === 3) {
              // popup para finalização das tasks filhas
              if (res.body['finalize_sons']) {
                this.$store.commit('snackbarButton/change_values', {
                  text: 'Deseja finalizar as tarefas de níveis abaixo?',
                  color: 'blue',
                  buttonColor: 'blue',
                  buttonText: 'Finalizar subtarefas',
                  buttonFunction: () => {
                    this.$store.commit('snackbarButton/change_values', {dialog: false})
                    this.$http.get(`api/finalize_lower_tasks/${res.body.id}`).then(response => {
                      this.$emit('reloadPage')
                      // Socket para atualizar a subtarefa na tela de gerenciamento de tarefas
                      this.$socket.emit('generalEvent', {
                        data: res.body.id,
                        notBroadcast: true,
                        responseEvent: 'reloadTaskSubTask',
                        room: `tasks${res.body.id}_manage`
                      })
                      this.$store.commit('snackbar/change_values', { text: 'Tarefas filhas finalizadas com sucesso!', color: 'success', dialog: true })
                      if (res.body['finalize_father']) {
                        this.finalizeFather(res.body)
                      }
                    })
                  },
                  dialog: true
                })
              // popup para finalização da task pai
              } else if (res.body['finalize_father']) {
                this.finalizeFather(res.body)
              }
              for (var element in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'deleteSocketCalendarTask',
                  room: `calendar${res.body.participants[element]}`
                })
              }
            }
            // caso haja mudança e o identifier antigo é de finalizado addiciona o via socket a tarefa no calendario
            if (!!res.body.before_status_identifier && res.body.before_status_identifier === 3) {
              for (element in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'addSocketCalendarTask',
                  room: `calendar${res.body.participants[element]}`
                })
              }
            }
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true})
            // verificar se o this.view = 4 é necessário
            this.view = 4
            this.sons = editedItem.sons
          },
          err => {
            console.log(err)
            // Caso o usuário ainda esteja na mesma tarefa e de erro Retorna os valores antigos
            if (this.editedItem['id'] == editedItem['id']) this.editedItem = JSON.parse(JSON.stringify(this.beforeEditedItem))
            if (err.body.message === 'notFoundTask') {
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
            } else if (err.body.message === 'actionDenied') {
              this.$store.commit('snackbar/change_values', {text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem edita-la.', color: 'warning', timeout: 10000, dialog: true})
            } else if (err.body.message === 'hasDependency') {
              this.$store.commit('snackbar/change_values', {text: 'Existem pré-requisitos para esta tarefa.', color: 'warning', timeout: 6000, dialog: true})
            } else if (err.body.message === 'dependentFinalized') {
              this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
            } else {
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
            }
            this.loading = false
            this.$store.commit('loader/change_dialog', false)
          }
        )
      },
      finalizeFather (task) {
        this.$store.commit('snackbarButton/change_values', {
          text: 'Deseja finalizar a tarefa mãe?',
          color: 'blue',
          buttonColor: 'blue',
          buttonText: 'Finalizar Tarefa',
          buttonFunction: () => {
            this.$store.commit('snackbarButton/change_values', {dialog: false})
            this.$http.post(`api/finalize_status`, {task_id: task['task_id']}).then(res => {
              // Caso o tempo da tarefa mãoe estiver rodando, finaliza ele.
              let params = JSON.parse(this.$auth.user().company.params)
              if (params['stopTime'] && params['stopTime']['active'] && params['stopTime']['status'].some((val) => { return val == task['task_status_id'] })) {
                // verifica se a tarefa mae está com o tempo contando, se tiver, para o tempo
                let stopWatchValues = this.$store.getters[`stopWatch/values`]
                if (stopWatchValues['active'] && stopWatchValues['task_id'] == task['id']) {
                  this.closeDuration()
                }
              }
              this.$store.commit('snackbar/change_values', { text: 'Tarefa mãe finalizada com sucesso!', color: 'success', dialog: true })
              // this.$emit('reloadPage')
              // insere o status e os participantes nos valores da tarefa mãe para poder alterar no socket
              // insere o finalize_father pois ele é verificado no socket se veio da opção de finalizar o pai, pois se tiver vindo deve dar um reload
              let taskItem = {id: task.task_id, task_status_id: res.body['status']['id'], status: res.body['status'], before_task_status_id: res.body['before_task_status_id'], finalize_father: true}
              taskItem['status'] = res.body['status']
              taskItem['participants'] = res.body['participants']
              // joga o socket para atualizar a tarefa pai na tela de gerenciamento de tarefas quando ela é editada
              this.$socket.emit('generalEvent', {
                data: {values: taskItem, entity: 'tarefa'},
                notBroadcast: true,
                responseEvent: 'editSocketManagementDetails',
                room: `tasks${task.task_id}_manage`
              })
              for (let user in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: taskItem,
                  notBroadcast: true,
                  responseEvent: 'reloadTasks',
                  room: `tasks${res.body.participants[user]}`
                })
              }
            }, err => {
              if (err.body.message === 'notFoundTask') {
                this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
              } else if (err.body.message === 'hasDependency') {
                this.$store.commit('snackbar/change_values', {text: 'Existem pré-requisitos para esta tarefa.', color: 'warning', timeout: 6000, dialog: true})
              } else if (err.body.message === 'dependentFinalized') {
                this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
              } else {
                this.$store.commit('snackbar/change_values', {text: 'Não foi possível finalizar a tarefa!.', color: 'error', dialog: true})
              }
            })
          },
          dialog: true
        })
      },
      changeQtdCustomFields (val) {
        this.qtdCustomFields = val
        this.forceAutoGrow = !this.forceAutoGrow
        // foca na descrição
        if (this.$refs.autofocus) {
          this.$nextTick(() => this.$refs.autofocus.focus())
        }
      },
      close () {
        if (this.view === 4) {
          this.$socket.emit('leaveRoom', {room: `tasks${this.editedItem.id}_manage`})
        }
        if (this.view === 3) {
          Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.editedItemDB)))
          this.view = 4
          this.$socket.emit('leaveRoom', {room: `tasks${this.editedItem.id}_edit`})
        } else {
          // no close da tela de inclusão zera os arquivos que estao a espera para ser adicionados caso tenha.
          this.$store.commit('customField/close_files')
          this.currentManageRoom = ''
          this.$socket.emit('leaveRoom', {room: this.currentManageRoom})
          // this.dialog = false
          this.view = 1
          // Object.assign(
          //   JSON.parse(JSON.stringify(this.defaultItem)), {})
          if (this.$route.query.return) {
            this.$router.push(`/${this.$route.query.return}`)
          } else if (this.$route.params.id) {
            this.$router.push('/tasks')
          }
        }
        // Fecha todos os campos caso tenha algum aberto
        this.fieldEditing = JSON.parse(JSON.stringify(this.defaultFieldEditing))
        this.$emit('close')
        this.selectedUser = null
        this.tasktemplate = null
        this.defaultItem = {identifier: '', user_id: '', connection_id: null, connection_company_id: null, team_id: '', category_id: '', client_id: '', task_status_id: '', id_text: '', begin: '', end: '', urgency: '', note: '', recurrence: {type: '', id_text: {each: '', days: '', months: ''}}}
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        // zera a quantidade dos campos personalizados para não ficar aparecendo quando abre novamente
        this.$store.commit('customField/change_values', [])
        this.changeQtdCustomFields(0)
      },
      closeFieldEditing (field = '') {
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        if (field !== '') this.fieldEditing[field] = true
        this.$refs.PCustomField.closeFieldEditing()
      },
      afterAddSocketDetails (item) {
        this.$data[item.details + '_length'] = this.editedItem[item.details].length
      },
      afterDeleteSocketDetails (item) {
        this.$data[item.details + '_length'] = this.editedItem[item.details].length
        if (item.details === 'users') {
          this.editedItem.durations.forEach(val => {
            if (val.user_id === item.values.user_id) {
              this.editedItem.durations.splice(this.editedItem.durations.indexOf(val), 1)
            }
          })
        }
      },
      beforeAddSocketDetails (item) {
        // Os lembretes são particulares, portanto não inserir caso o lembrete seja de outro usuário
        if (item.details === 'reminders') {
          return item.values.user_id === this.$auth.user().id
        }
      },
      editItem (item, view = 3) {
        this.previousView = this.view
        this.view = view
        // this.dialog = this.view !== 1
        Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(item)))
        // FOI TIRADO O PARSE E O STRINGFY PARA QUE O VINCULO CONTINUE E QUANDO ALTERE UM DETALHE ALTERE TAMBEM NOS ITEMS
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
        // Criado o beforeEditedItem para caso sejá necessário acessar algum dado antes da alteração deste
        Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(item)))
        // Quando vai pra tela de gerenciamento, recarrega os customFields
        if (this.view === 4) {
          // setTimeout para dar tempo do origimView mudar pra 4
          setTimeout(() => {
            if (this.$refs.PCustomField) this.$refs.PCustomField.getCustomFields('task_id', this.editedItem['id'], this.editedItem['template_id'])
          }, 100)
          // Adicionar o usuário na sala caso ele tenha ido em salvar e gerenciar
          this.$socket.emit('joinRoom', {room: `tasks${this.editedItem['id']}_manage`, username: this.$auth.check() ? this.$auth.user().id_text : 'Anonimo', view: 4})
        }
        // this.$socket.emit('joinRoom', {room: `${this.socketRoom}_${this.editedItem.id}`})
        // Ao editar foca no campo que possui o ref=autofocus
        let _this = this
        setTimeout(function () {
          if (_this.$refs.autofocus) {
            _this.$nextTick(() => _this.$refs.autofocus.focus())
          }
        }, 10)
        this.$store.commit('loader/change_dialog', false)
      },
      arrayRules (val) {
        if (Array.isArray(val) && val.length > 0) {
          return this.requiredRule(this.translate('table.' + this.entity + '.field.category_id'))
        }
        return []
      },
      // verifica se é array e se não está vazio
      notEmptyArray (val) {
        let result = false
        if (Array.isArray(val) && val.length > 0) {
          result = true
        }
        return result
      },
      // statusChanged quando altera o status de uma subtarefa dentro do gerenciamento de tarefas, deve atualizar a tela de consulta
      statusChanged (task) {
        // se a tarefa for finalizada, aumenta no status.
        // if (task['status']['identifier'] && task['status']['identifier'] === 3 && task['old_status']) {}
        this.$emit('savePut', task)
      }
    },
    destroyed () {
      if (this.editedItem.id) {
        this.$socket.emit('leaveRoom', {room: `tasks${this.editedItem.id}_manage`})
        this.$socket.emit('leaveRoom', {room: `tasks${this.editedItem.id}_edit`})
      }
    },
    watch: {
      // verifica se a rota mudou, pois se tiver mudado devera buscar os dados da tarefa novamente
      '$route.params.id' (val) {
        this.initializeCreate()
      },
      'editedItem.recurrence': {
        deep: true,
        handler (val, oldVal) {
          this.getRecurrenceText()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PTaskEditable.vue